// ArChat Language Extension
// Created: 13-03-2026 00:00:00
// Author: SIVOL® - Aldo Frias - Argentina

import { translationsEn } from './translations.en.js';
import { PRESET_LOCALES } from '../presencePresetI18n.js';

export const translationsTr = {
  ...translationsEn,
  'common.loading': 'Yükleniyor…',
  'common.cancel': 'İptal',
  'common.confirm': 'Onayla',
  'common.close': 'Kapat',
  'common.sending': 'Gönderiliyor...',
  'common.language': 'Dil',
  'menu.contacts': 'Kisiler',
  'menu.dashboard': 'Panel',
  'menu.help': 'Yardim',
  'menu.logout': 'Cikis',
  'menu.files': 'Dosyalarim',
  'reviews.menu_title': 'Degerlendirmeler',
  'reviews.rate_archat': "ArChat'i degerlendir",
  'reviews.my_review': 'Degerlendirmem',
  'profile.my_profile': 'Profilim',
  'profile.status': 'Durum',
  'profile.invite_email': 'E-posta ile kisi davet et',
  'profile.sent_invitations': 'Gonderilen davetler',
  'profile.logout': 'Cikis',
  'invitation.title': 'E-posta ile kisi davet et',
  'invitation.modal.title': 'Davet gönder',
  'invitation.modal.description': 'ArChat® üzerinde sohbet etmek için birini davet et. Davet bağlantısı içeren bir e-posta alacak.',
  'invitation.email.label': 'Davetli e-posta adresi',
  'invitation.email.required': 'E-posta zorunludur',
  'invitation.email.invalid': 'Geçerli bir e-posta adresi girin',
  'invitation.language.label': 'Davetlinin tercih ettiği dil',
  'invitation.language.help': 'E-posta bu dilde gönderilir',
  'invitation.mode.label': 'Konuşma modu',
  'invitation.mode.profesional': 'Profesyonel',
  'invitation.mode.profesional.description': 'Resmi ve profesyonel konuşma',
  'invitation.mode.tecnico': 'Teknik',
  'invitation.mode.tecnico.description': 'Teknik ve uzman konuşma',
  'invitation.mode.casual': 'Gündelik',
  'invitation.mode.casual.description': 'Samimi ve arkadaşça konuşma',
  'invitation.message.label': 'Kişisel mesaj (isteğe bağlı)',
  'invitation.message.placeholder': 'Davetli için kişisel bir mesaj yazın...',
  'invitation.send': 'Davet gönder',
  'invitation.sending': 'Gönderiliyor...',
  'invitation.success': 'Davet başarıyla gönderildi',
  'invitation.success.title': 'Davet gönderildi',
  'invitation.error': 'Davet gönderilirken hata oluştu',
  'invitation.list.title': 'Gönderilen davetler',
  'invitation.list.empty': 'Henüz davet göndermediniz',
  'invitation.list.email': 'E-posta',
  'invitation.list.language': 'Dil',
  'invitation.list.mode': 'Mod',
  'invitation.list.status': 'Durum',
  'invitation.list.created': 'Gönderildi',
  'invitation.list.expires': 'Sona erme',
  'invitation.list.actions': 'İşlemler',
  'invitation.status.pending': 'Beklemede',
  'invitation.status.accepted': 'Kabul edildi',
  'invitation.status.expired': 'Süresi doldu',
  'invitation.status.cancelled': 'İptal edildi',
  'invitation.cancel': 'İptal et',
  'invitation.cancel.confirm': 'Bu daveti iptal etmek istediğinize emin misiniz?',
  'invitation.cancel.success': 'Davet başarıyla iptal edildi',
  'invitation.cancel.title': 'İptali onayla',
  'invitation.resend': 'E-postayı tekrar gönder',
  'invitation.resend.title': 'Daveti tekrar gönder',
  'invitation.resend.success': 'Davet e-postası başarıyla tekrar gönderildi',
  'invitation.resend.error': 'Davet e-postası tekrar gönderilirken hata oluştu',
  'status.available': 'Musait',
  'status.busy': 'Mesgul',
  'status.in_call': 'Aramada',
  'status.away': 'Uzakta',
  'status.offline': 'Cevrimdisi',
  'status.custom': 'Ozel mesaj',
  'status.set_title': 'Kullanilabilirlik durumu',
  'status.set_button': 'Durumu degistir',
  'status.placeholder': 'Istege bagli mesaj (ornegin: Toplantida)',
  'presence.title': 'Durum',
  'presence.currentStatus': 'Mevcut durum:',
  'presence.changeStatus': 'Durum degistir',
  'presence.status.online': 'Cevrimici',
  'presence.status.online.title': 'Cevrimici - Herkes gorebilir',
  'presence.status.online.description': 'Cevrimici: Tum kisilere gorunur',
  'presence.status.idle': 'Bosta',
  'presence.status.idle.title': 'Bosta - Gecici olarak uzakta oldugunuzu belirtir',
  'presence.status.idle.description': 'Bosta: Gecici olarak musait olmadiginizi belirtir',
  'presence.status.dnd': 'Rahatsiz etmeyin',
  'presence.status.dnd.title': 'Rahatsiz etmeyin - Rahatsiz edilmek istemediginizi belirtir',
  'presence.status.dnd.description': 'Rahatsiz etmeyin: Rahatsiz edilmek istemediginizin gorunen isareti',
  'presence.status.busy': 'Mesgul',
  'presence.status.busy.title': 'Mesgul - Musait degil',
  'presence.status.busy.description': 'Mesgul: Musait degil',
  'presence.status.offline': 'Cevrimdisi',
  'presence.status.offline.title': 'Bagli degil - Cevrimdisi gorun',
  'presence.status.offline.description': 'Cevrimdisi: Bagli degil gibi gorun',
  'presence.status.custom': 'Ozel',
  'presence.status.custom.title': 'Ozel - Emoji ile benzersiz durum',
  'presence.status.custom.description': 'Ozel: Emoji ve istege bagli sure ile benzersiz durum',
  'presence.unavailable': 'Durumlar kullanilamiyor',
  'presence.maintenance': 'Sunucu bakimda',
  'presence.custom.title': 'Ozel durum',
  'presence.custom.status': 'Ozel durum',
  'presence.custom.placeholder': 'Orn: Kahve molasindayim ☕',
  'presence.custom.emoji': 'Emoji (istege bagli)',
  'presence.custom.emojiHelp': 'Bir emoji secin veya yazin',
  'presence.custom.temporary': 'Gecici durum (otomatik sona erer)',
  'presence.custom.expiration': 'Bitis tarihi',
  'presence.custom.expirationHelp': 'Suresi dolunca durum "Cevrimici" olur',
  'presence.custom.suggestions': 'Oneriler',
  'presence.custom.preview': 'Onizleme',
  'presence.custom.save': 'Durumu kaydet',
  'presence.custom.required': 'Ozel durum zorunludur',
  'presence.custom.maxLength': 'Maksimum 64 karakter',
  'presence.custom.expirationRequired': 'Bir bitis tarihi secmelisiniz',
  'presence.custom.expirationFuture': 'Bitis tarihi gelecekte olmali',
  'presence.custom.selectEmoji': 'Emoji sec',
  'dashboard.title': 'Gösterge paneli',
  'dashboard.planUsage': 'Plan kullanımı',
  'dashboard.filesSummary': 'Dosyalarım',
  'dashboard.promotions': 'Kampanyalar',
  'dashboard.sessions': 'Aktif oturumlar',
  'dashboard.explore': 'Keşfet',
  'dashboard.noSessions': 'Aktif oturum yok',
  'dashboard.welcomeTitle': "ArChat®'a hoş geldiniz",
  'dashboard.welcomeSubtitle': 'Her dilde iletişim kurun.',
  'dashboard.stepInvite': 'Adım 1: ilk kişinizi davet edin',
  'dashboard.stepMessage': 'Adım 2: ilk mesajı gönderin',
  'dashboard.inviteContact': 'Kişi davet et',
  'dashboard.exploreArChat': "ArChat'i keşfet",
  'dashboard.promotionsTitle': 'Kampanyalar',
  'dashboard.promotionsText': 'Davet ve ödül programı özeti.',
  'dashboard.viewPromotions': 'Kampanyaları gör',
  'dashboard.usageTitle': 'Plan kullanımı',
  'dashboard.sessionsTitle': 'Aktif oturumlar',
  'dashboard.sessionsEmpty': 'Aktif oturum yok',
  'dashboard.filesTitle': 'Dosyalarım',
  'dashboard.viewFiles': 'Dosyaları aç',
  'dashboard.noBlocks': 'Aktif blok yok. Ayarlarda en az birini açın.',
  'dashboard.openSettings': 'Ayarları aç',
  'dashboard.goToContacts': 'Kişilere git',
  'dashboard.filesVisible': 'Görünen dosyalar',
  'dashboard.filesSampleNote': 'İlk sayfaya göre (500+’ya kadar).',
  'dashboard.card.contacts': 'Kisiler',
  'home.language': 'Dil',
  'auth.invalid_credentials': 'Kullanıcı adı veya şifre hatalı.',
  'auth.user_not_found': 'Kullanıcı bulunamadı.',
  'auth.user_inactive': 'Hesabınız devre dışı. Yöneticiyle iletişime geçin.',
  'auth.captcha_failed': 'CAPTCHA hatalı. Yanıtınızı kontrol edin.',
  'auth.generic_error': 'Bir hata oluştu. Lütfen tekrar deneyin.',
  'auth.password_mismatch': 'Şifreler eşleşmiyor.',
  'auth.rate_limit': 'Çok fazla deneme. Lütfen biraz bekleyip tekrar deneyin.',
  'contacts.no_contacts': 'Kişi yok',
  'contacts.invite_contact': 'Kişi davet et',
  'contacts.title': 'Kişiler',
  'contacts.search': 'Kişi ara',
  'contacts.sort': 'Sırala',
  'contacts.sortByName': 'Ada göre',
  'contacts.sortByStatus': 'Duruma göre',
  'contacts.sortByRecent': 'En yeni',
  'contacts.filter': 'Filtrele',
  'contacts.filterAll': 'Tümü',
  'contacts.filterAvailable': 'Müsait',
  'contacts.filterInvited': 'Davetliler',
  'contacts.filterBlocked': 'Engellenenler',
  'contacts.pending_invitations': 'Bekleyen davetler',
  'contacts.status.invitation_sent': 'Davet gönderildi',
  'contacts.conversations': 'Konuşmalar',
  'contacts.search_contact': 'Kişi ara',
  'contacts.empty.title': 'Henüz kişi yok',
  'contacts.empty.message': 'Davet ederek ilk sohbetinizi başlatın.',
  'contacts.empty.invite_button': 'Kişi davet et',
  'profile.title': 'Profilim',
  'profile.edit': 'Düzenle',
  'profile.save': 'Değişiklikleri Kaydet',
  'profile.cancel': 'İptal',
  'profile.language': 'Dil',
  'suggestions.title': 'Öneriler',
  'suggestions.form.title': 'Öneri başlığı',
  'suggestions.form.message': 'Fikrinizi açıklayın',
  'suggestions.form.submit': 'Öneri gönder',
  'suggestions.send': 'Öneri gönder',
  'suggestions.captcha_placeholder': 'Sonuç',
  'suggestions.cooldown': 'Başka bir öneri göndermeden önce {minutes} dakika beklemelisiniz.',
  'suggestions.success_title': 'Öneri gönderildi',
  'suggestions.success_message': 'Öneriniz başarıyla gönderildi. Takip numarası: {id}',
  'suggestions.success': 'Öneriniz için teşekkürler. Ekibimiz inceleyecek.',
  'suggestions.success.title': 'Öneriniz için teşekkürler!',
  'suggestions.success.reference': 'Referans',
  'suggestions.success.review': 'Ekibimiz fikrinizi inceleyecek.',
  'suggestions.success.email': 'Ayrıca size bir onay e-postası gönderdik.',
  'suggestions.success.copy': 'Kopyala',
  'suggestions.success.copied': 'Referans kopyalandı',
  'suggestions.form.required': 'Başlık ve mesaj zorunludur.',
  'suggestions.error': 'Gönderilemedi. Lütfen tekrar deneyin.',
  'suggestions.sendSuccess': 'Öneriniz başarıyla gönderildi.',
  'suggestions.sendError': 'Öneri gönderilemedi. Lütfen tekrar deneyin.',
  'suggestions.sent': 'Öneri başarıyla gönderildi.',
  'suggestions.new': 'Yeni öneri',
  'suggestions.empty': 'Henüz öneri göndermediniz.',
  'suggestions.admin_note': 'Ekip notu',
  'suggestions.status.pending': 'Beklemede',
  'suggestions.status.reviewed': 'İncelendi',
  'suggestions.status.planned': 'Planlandı',
  'suggestions.status.implemented': 'Uygulandı',
  'suggestions.status.rejected': 'Reddedildi',
  'errors.suggestionSend': 'Öneri gönderilemedi. Lütfen tekrar deneyin.',
  'help.title': 'ArChat® Yardım',
  'help.howWorks.title': 'ArChat® nasıl çalışır',
  'help.languages.title': 'Diller',
  'help.languages.point1': '{count} dil desteği.',
  'help.languages.point2': 'Bayraklı görsel dil seçici.',
  'notifications.title': 'Bildirimler',
  'notifications.empty': 'Bildirim yok',
  'errors.generic': 'Beklenmeyen bir hata oluştu.',
  'errors.network': 'Bağlantı hatası. Lütfen tekrar deneyin.',
  'errors.required': 'Bu alan zorunludur.',
  'contacts.controls.search_placeholder': 'Kişi ara...',
  'contacts.controls.search_label': 'Kişi ara',
  'contacts.controls.sort_label': 'Sırala',
  'contacts.controls.sort.name': 'Ad',
  'contacts.controls.sort.status': 'Durum',
  'contacts.controls.sort.recent': 'Son',
  'contacts.controls.sort.manual': 'Elle',
  'contacts.controls.sort.manual_drag_hint': 'Yeniden sıralamak için sürükleyin',
  'contacts.controls.filter_label': 'Durum',
  'contacts.controls.filter.all': 'Tümü',
  'contacts.controls.filter.available': 'Müsait',
  'contacts.controls.filter.invited': 'Davetliler',
  'contacts.controls.filter.blocked': 'Engellenenler',
  'contacts.controls.filter.favorites': 'Favoriler',
  'promotions.invite.message': 'Sizi ArChat\'e davet ediyorum; dilediğiniz dilde konuşun. İkimiz de fayda sağlıyoruz.',
  'promotions.progress.pending': 'Ödüllerin kilidini açmak için bekleyen davetiyeleriniz var.',
  'promotions.progress.in_progress': 'Davetiyeleriniz devam ediyor: ödüller gerçek bir konuşmanın ardından etkinleştirilir.',
  'promotions.progress.remaining': 'Ödülünüzü almak için {count} konuşmaya daha ihtiyacınız var.',
  'promotions.progress.sent_count': 'Gönderilmiş',
  'promotions.progress.pending_count': 'Askıda olması',
  'promotions.progress.in_progress_count': 'Devam etmekte',
  'promotions.progress.completed_count': 'Tamamlanmış',
  'promotions.banner.empty': 'Şimdi başlayın: kişileri davet edin ve avantajların kilidini açın.',
  'promotions.banner.pending': 'Bekleyen davetiyeleriniz var: gerçek bir sohbeti tamamlayın ve ödüller kazanın.',
  'promotions.banner.reward': 'Zaten ödüllerin kilidini açtınız! Kazanımlarınızı artırmak için davet etmeye devam edin.',
  'promotions.cta.copy': 'Mesajı ve bağlantıyı kopyala',
  'promotions.cta.copied': 'Mesaj kopyalandı',
  'promotions.cta.copy_error': 'Mesaj kopyalanamadı',

  'promotions.title': 'Promosyonlar ve ödüller',
  'promotions.subtitle': 'Gerçek kullanım yoluyla kişileri davet edin ve avantajların kilidini açın.',
  'promotions.how_it_works': 'Nasıl çalışır?',
  'promotions.step1': 'Profilinizden bir kişiyi davet edin.',
  'promotions.step2': 'Kabul edip gerçek etkileşimle sohbet ettiklerinde otomatik olarak doğrulanır.',
  'promotions.step3': 'Ödül hesabınıza aktarılır ve ilerlemeniz güncellenir.',
  'promotions.rewards.title': 'Ödüller',
  'promotions.reward.invite': 'Doğrulanan her yönlendirme için ödül.',
  'promotions.reward.milestone': 'Büyüme kilometre taşları için bonuslar.',
  'promotions.reward.ranking': 'En iyi ağ oluşturucular sıralamasında görünürlük.',
  'promotions.progress.title': 'İlerlemeniz',
  'promotions.progress.sent': 'Gönderilmiş',
  'promotions.cta.invite': 'Kişiyi davet et',
  'promotions.banner': 'Promosyonları etkinleştirin: gerçek kullanım için davet edin ve ödüller kazanın.',
  'promotions.modal.title': 'Promosyon programı',
  'promotions.modal.body': 'Doğrulanan davetiye başına +10.000 karakter kazanın.\\nBugün davet edin ve ödüllerin kilidini açın.',
  'promotions.modal.cta': 'Promosyonları görüntüle',
  'login.title': 'Giriş yap',
  'login.slogan': 'Sınırsız sohbetler!',
  'login.username': 'Kullanıcı adı',
  'login.password': 'Şifre',
  'login.submit': 'Giriş yap',
  'login.loading': 'Yükleniyor...',
  'login.autoRegister.title': 'Otomatik kayıt',
  'login.autoRegister.description': 'Hesabınız yoksa kullanıcı adı, şifre ve e-postanızı girin. Hesap otomatik oluşturulur ve e-posta ile bir onay bağlantısı alırsınız.',
  'login.forgotPassword': 'Şifrenizi mi unuttunuz?',
  'login.passwordRecovery.title': 'Şifre kurtarma',
  'login.passwordRecovery.description': 'Kurtarma bağlantısı almak için e-postanızı girin.',
  'login.passwordRecovery.emailLabel': 'E-posta',
  'login.passwordRecovery.emailPlaceholder': 'E-postanızı girin',
  'login.passwordRecovery.emailHelp': 'E-postanıza bir kurtarma bağlantısı gönderilecek',
  'login.passwordRecovery.send': 'Gönder',
  'login.passwordRecovery.success': 'E-postanıza bir kurtarma bağlantısı gönderildi. Gelen kutunuzu kontrol edin.',
  'login.passwordRecovery.successTitle': 'E-posta gönderildi',
  'login.passwordRecovery.successMessage': 'Şifrenizi sıfırlamak için talimat içeren bir e-posta gönderdik.\nGelen kutunuzu ve spam klasörünü kontrol edin. Bağlantının gelmesi birkaç dakika sürebilir.',
  'login.passwordRecovery.devExplanation': 'Geliştirme modunda e-posta gelen kutunuza gönderilmez; önizleme için kaydedilir. İçeriği ve kurtarma bağlantısını görmek için «E-postayı görüntüle»yi kullanın.',
  'login.passwordRecovery.devSinkNotice': '⚠️ Geliştirme modu: Bu e-posta gelen kutunuza GÖNDERİLMEDİ. Oluşturulan iletiyi açmak ve bağlantıyı kullanmak için «E-postayı görüntüle»yi kullanın.',
  'login.passwordRecovery.invalidEmail': 'Lütfen geçerli bir e-posta adresi girin',
  'login.error.invalidPassword': 'Geçersiz şifre',
  'auth.require_email': 'Kaydı tamamlamak için e-posta gereklidir. Lütfen e-postanızı girin.',
  'auth.tenant_mismatch': 'Hesabınız bu ortama ait değil. Yöneticiyle iletişime geçin.',
  'auth.account_blocked': 'Hesap etkin değil. Yeniden etkinleştirmek için e-postanızı girin.',
  'auth.device_limit_reached': 'Cihaz sınırına ulaşıldı. Başka bir cihazda oturumu kapatın veya planınızı yükseltin.',
  'auth.login.device_limit.title': 'Oturum veya cihaz sınırına ulaşıldı',
  'auth.login.device_limit.body': 'Planınız sınırlı sayıda etkin oturum veya cihaza izin verir. Giriş yapmak için başka bir cihazda oturumu kapatın veya başka bir etkin oturumu sonlandırın, ardından tekrar deneyin.',
  'auth.password_incorrect': 'Şifre yanlış.',
  'auth.login.password_error_title': 'Yanlış şifre',
  'auth.login.password_attempts_hint': 'Şifrenizi doğru girmek için 3 deneme hakkınız var. Bu denemeleri aşarsanız şifrenizi sıfırlamanız gerekir.',
  'auth.login.password_attempts_exhausted_title': 'Deneme limiti aşıldı',
  'auth.login.password_attempts_exhausted_body': 'İzin verilen 3 denemeyi aştınız. Devam etmek için «Şifrenizi mi unuttunuz?» üzerinden şifrenizi sıfırlayın.',
  'auth.login.go_to_reset_password': 'Şifre sıfırlamaya git',
  'auth.login.password_remaining_two': '2 deneme hakkınız kaldı.',
  'auth.login.password_remaining_one': '1 deneme hakkınız kaldı.',
  'auth.login.password_attempts_locked_inline': 'Maksimum deneme sayısına ulaşıldı. Şifrenizi sıfırlamalısınız.',
  'auth.account_inactive_email_mismatch': 'Hesap etkin değil ve e-posta eşleşmiyor.',
  'auth.captcha_expired': 'Doğrulamanızın süresi doldu. Yeni bir tane otomatik oluşturuldu.',
  'auth.captcha_required': 'Lütfen güvenlik doğrulamasını (CAPTCHA) tamamlayın.',
  'auth.unauthorized': 'Erişim izniniz yok.',
  'auth.method_not_allowed': 'Yönteme izin verilmiyor.',
  'auth.invalid_data': 'Geçersiz veri.',
  'auth.credentials_required': 'Kullanıcı adı ve şifre gereklidir.',
  'auth.csrf_invalid': 'Geçersiz oturum. Sayfayı yenileyin ve tekrar deneyin.',
  'auth.username_taken': 'Bu kullanıcı adı zaten kayıtlı. Giriş yapın veya başka bir ad seçin.',
  'auth.username_unavailable': 'Bu kullanıcı adı kullanılamıyor.',
  'auth.nick_no_spaces': 'Takma adlarda boşluk kullanılamaz.',
  'auth.password_too_short': 'Şifre en az 6 karakter olmalıdır.',
  'auth.confirm_success': 'Hesap onaylandı. Girişe yönlendiriliyorsunuz...',
  'auth.confirm_already_active': 'Hesabınız zaten etkin. Giriş yapabilirsiniz.',
  'auth.reset_sent': 'E-posta kayıtlıysa şifrenizi sıfırlamak için talimatlar alırsınız.',
  'auth.reset_token_invalid': 'Geçersiz veya eksik bağlantı.',
  'auth.reset_token_expired': 'Bu bağlantının süresi doldu. «Şifrenizi mi unuttunuz?» üzerinden yenisini isteyin.',
  'auth.reset_done': 'Şifre güncellendi. Artık giriş yapabilirsiniz.',
  'auth.reset_fatal': 'Kaydetme hatası. Daha sonra tekrar deneyin.',
  'resetPassword.page.title': 'Yeni şifre',
  'resetPassword.page.description': 'Yeni şifrenizi girin (en az 6 karakter).',
  'resetPassword.newPassword': 'Yeni şifre',
  'resetPassword.newPasswordPlaceholder': 'En az 6 karakter',
  'resetPassword.submit': 'Şifreyi sıfırla',
  'resetPassword.success': 'Şifre güncellendi. Girişe yönlendiriliyorsunuz...',
  'resetPassword.backToLogin': 'Girişe dön',

  'account.delete.section_title': 'Hesabı sil',
  'account.delete.description': 'Hesabınızı silmek tüm verilerinizi, mesajlarınızı, kişilerinizi ve ayarlarınızı kalıcı olarak kaldırır. Bu işlem geri alınamaz.',
  'account.delete.button': 'Hesabımı sil',
  'accountDeletion.title': 'Hesap ve veri silme',
  'accountDeletion.description': 'ArChat hesabınızın ve ilişkili verilerin silinmesini talep edin.',
  'accountDeletion.openRequest': 'Hesap ve veri silme talep et',
  'account.delete.confirm_title': 'Hesabı sil',
  'account.delete.confirm_message': 'Hesabınızı silmek istediğinizden emin misiniz? Gelen kutunuza bir onay e-postası gönderilecektir. Silme kalıcı ve geri alınamazdır.',
  'account.delete.email_sent_title': 'E-posta gönderildi',
  'account.delete.email_sent': 'Size bir onay e-postası gönderdik. Gelen kutunuzu kontrol edin ve silmeyi onaylamak için bağlantıya tıklayın.',
  'account.delete.error': 'İstek işlenemedi. Lütfen tekrar deneyin.',
  'account.delete.confirm_page_title': 'Hesap silmeyi onayla',
  'account.delete.confirm_page_desc': 'ArChat hesabınızı kalıcı olarak silmek üzeresiniz. Tüm veriler, mesajlar, kişiler ve ayarlar kaldırılacaktır. Bu işlem geri alınamaz.',
  'account.delete.confirm_final_button': 'Evet, hesabımı kalıcı olarak sil',
  'account.delete.cancel_go_back': 'İptal et ve geri dön',
  'account.delete.done_title': 'Hesap silindi',
  'account.delete.done_message': 'Hesabınız başarıyla silindi. Tüm veriler kaldırıldı.',
  'account.delete_token_expired': 'Silme bağlantısının süresi doldu veya artık geçerli değil. Profilinizden yenisini isteyin.',
  'account.delete_token_invalid': 'Geçersiz veya eksik silme bağlantısı.',
  'account.delete_email_failed': 'Onay e-postası gönderilemedi. Daha sonra tekrar deneyin.',
  'account.delete_error': 'Silme işlenirken hata oluştu. Daha sonra tekrar deneyin.',

  'mail.send_failed': 'Kurtarma e-postası gönderilemedi. SMTP yapılandırmasını kontrol edin veya daha sonra tekrar deneyin.',
  'auth.register_success_email_sent': 'Hesap başarıyla oluşturuldu. Bir onay e-postası gönderildi. Gelen kutunuzu (ve spam) kontrol edin ve hesabı etkinleştirmek için bağlantıya tıklayın.',
  'auth.register_success_email_pending': 'Hesap oluşturuldu ancak onay e-postası gönderilirken sorun oluştu. Etkinleştirme anahtarı hâlâ geçerli. Yöneticiyle iletişime geçin veya yeni bir onay e-postası isteyin.',
  'auth.email_not_verified': 'Hesabı etkinleştirmek için e-postanızı onaylamalısınız.',
  'auth.email_not_verified_title': 'Hesap onay bekliyor',
  'auth.email_send_failed': 'E-postayı gönderemedik. Tekrar deneyin veya e-postanızı değiştirin.',
  'auth.email_send_failed_title': 'E-posta gönderilemedi',
  'auth.register.email_failed.title': 'Hesap oluşturuldu',
  'auth.register.email_failed.message': 'Hesabınız oluşturuldu ancak onay e-postası gönderilirken sorun oluştu. Spam klasörünü kontrol edin veya yeni bir e-posta isteyin.',
  'auth.register.success.title': 'Hesap oluşturuldu',
  'auth.register.success.message': 'Hesap başarıyla oluşturuldu. Bir onay e-postası gönderildi. Gelen kutunuzu (ve spam) kontrol edin ve hesabı etkinleştirmek için bağlantıya tıklayın.',
  'auth.resend_sent': 'Onay e-postası yeniden gönderildi.',
  'auth.resend_activation': 'Etkinleştirme e-postasını yeniden gönder',
  'auth.resend_email': 'E-postayı yeniden gönder',
  'auth.retry_resend': 'Yeniden dene',
  'auth.change_email': 'E-postayı değiştir',
  'auth.ver_email': 'E-postayı görüntüle',
  'auth.already_verified': 'Hesap zaten doğrulanmış.',
  'auth.confirm_email_title': 'E-postayı onayla',
  'auth.confirm_email_text': 'Etkinleştirme bağlantısı şuraya gönderilecek:',
  'auth.confirm_email_edit': 'Düzenle',
  'auth.confirm_email_confirm': 'Onayla',
  'auth.confirm_email_typo_hint': '***@{suggestion} mu demek istediniz?',
  'brand.slogan': 'Dilin ne olursa olsun anlaşılma gücü',
  "brand.appName": "ArChat®",
  "brand.name": "ArChat®",
  "home.title": "ArChat®",
  'home.slogan': 'Dilin ne olursa olsun anlaşılma gücü',
  'home.tagline': 'Otomatik çeviri ile mesajlaşma',
  'home.login': 'Giriş yap',
  'home.register': 'Hesap oluştur',
  'terms.title': 'Şartlar ve koşullar',
  'terms.accept': 'Kabul et ve devam et',
  'terms.reject': 'Reddet',
  'terms.rejectShort': 'Kabul etmiyorum',
  'terms.readAndAccept': 'Şartları ve koşulları okudum ve kabul ediyorum',
  'terms.cancel': 'İptal',
  'register.pageTitle': 'Hesap oluştur',
  'register.pageSubtitle': 'Hesabınızı oluşturmak için bilgilerinizi girin.',
  'register.submitLabel': 'Hesap oluştur',
  'register.confirm_title': 'Hesabı onayla',
  'register.confirm_message': 'Şu hesabı oluşturmak üzeresiniz:',
  'register.confirm': 'Onayla',
  'register.creatingAccount': 'Hesabınız oluşturuluyor…',
  'register.login_link': 'Zaten hesabınız var mı?',
  'register.password_hint': 'En az 6 karakter',
  'register.checking': 'Kontrol ediliyor…',
  'register.username_taken': 'Bu kullanıcı adı zaten kullanılıyor.',
  'register.available': 'Uygun',
  'register.emailAlreadyExists': 'Bu e-posta zaten kayıtlı.',
  'register.continue': 'Devam',
  'login.demo.title': 'Demo erişimi',
  'login.demo.credentials': 'Kullanıcı: demo / Şifre: demo',
  'login.email.placeholder': 'Hesabı onaylamak için e-postanızı girin',
  'login.email.help': 'E-postanıza bir onay bağlantısı gönderilecek',
  'app.install': "ArChat'i yükle",
  'app.install_ios_hint': 'Yüklemek için: Paylaş > Ana Ekrana Ekle',
  'common.edit': 'Düzenle',
  'common.on': 'Açık',
  'common.off': 'Kapalı',
  'common.back': 'Geri',
  'common.backToStart': 'Ana sayfaya dön',
  'common.changeUser': 'Kullanıcıyı değiştir',
  'common.refresh': 'Yenile',
  'common.request_id_label': 'İstek kimliği',
  'login.email.invalid': 'Lütfen geçerli bir e-posta girin',
  'system.processing': 'İşleniyor...',
  'captcha.solve': 'CAPTCHA\'yı doğru şekilde çözün',
  'captcha.generateError': 'CAPTCHA oluşturulurken hata oluştu. Sayfayı yenileyin.',
  'captcha.label': 'Güvenlik doğrulaması',
  'security.verification_title': 'Güvenlik doğrulaması',
  'security.captcha_question': 'Doğrulama sorusu',
  'security.enter_answer': 'Yanıtı girin',
  'captcha.description': 'Devam etmek için işlemi çözün.',
  'captcha.required': 'Devam etmek için CAPTCHA yanıtını girmelisiniz.',
  'captcha.incorrect': 'CAPTCHA yanıtı yanlış.',
  'captcha.placeholder': 'Yanıtı girin',
  'captcha.questionFormat': '{a} + {b} kaçtır?',
  'menu.conversations': 'Sohbetler',
  'menu.admin': 'Yönetim',
  'menu.profile': 'Profilim',
  'menu.settings': 'Ayarlar',
  'menu.promotions': 'Promosyonlar',
  "navbar.contacts": "Kişiler",
  "navbar.profile": "Profilim",
  "navbar.settings": "Yapılandırma",
  "navbar.logout": "Dışarı çıkmak",
  "navbar.status": "Durum",
  "navbar.users": "Kullanıcılar",
  'navbar.no_blocked_users': 'Engellenen kullanıcı yok',
  'navbar.blocked_users_title': 'Engellenen kullanıcılar',
  'contacts.blocked_users_title': 'Engellenen kullanıcılar',
  'contacts.country_label': 'Ülke',
  'contacts.not_reported': 'Belirtilmedi',
  "navbar.user_fallback": "Kullanıcı kimliği}",
  "navbar.open_guide": "Rehber",
  "help.view_initial_guide": "İlk kılavuza bakın",
  "help.how_archat_works": "ArChat® nasıl çalışır?",
  "help.registration": "Kayıt",
  "help.private_invitations": "Özel davetiyeler",
  "help.messaging": "Mesajlaşma",
  "help.security": "Güvenlik",
  "invitation.quick_button": "Kişiyi davet et",
  "onboarding.title": "ArChat®'e hoş geldiniz",
  "onboarding.subtitle": "Herkesle herhangi bir dilde iletişim kurun.",
  "onboarding.step1.label": "1. Adım",
  "onboarding.step1.text": "İlk kişinizi davet edin",
  "onboarding.step2.label": "2. Adım",
  "onboarding.step2.text": "İlk mesajınızı gönderin",
  "onboarding.actions.invite": "Kişiyi davet et",
  "onboarding.actions.explore": "ArChat®'i keşfedin",
  "onboarding.welcome_title": "ArChat®'e hoş geldiniz",
  "onboarding.welcome_subtitle": "Herkesle herhangi bir dilde iletişim kurun.",
  "onboarding.step1": "1. Adım",
  "onboarding.step1_title": "1. Adım",
  "onboarding.step1_description": "İlk kişinizi davet edin",
  "onboarding.step2": "2. Adım",
  "onboarding.step2_title": "2. Adım",
  "onboarding.step2_description": "İlk mesajınızı gönderin",
  "onboarding.invite_contact": "Kişiyi davet et",
  "onboarding.explore_archat": "ArChat®'i keşfedin",
  "referral.promo": "10.000 karakteri davet edin ve kazanın",
  "referral.stats.sent": "Gönderilmiş",
  "referral.stats.accepted": "Kabul edildi",
  "referral.stats.rewards": "Ödüller",
  "referral.reward.pending": "Küpe",
  "referral.reward.granted": "Dolu",
  "referral.reward.invalid": "Geçersiz",
  "referral.reward.in_progress": "Kullanımda",
  "referral.limit.reached": "Ödül sınırına ulaşıldı",
  "referral.waiting.usage": "Siz ve misafiriniz aynı sohbette en az bir gerçek kısa mesaj gönderdiğinizde (sunucu tarafından doğrulanmış) her biri +10.000 karakter.",
  "menu.open": "Menü",
  "contacts.controls.hide_non_favorites": "Favori olmayan kişileri gizle",
  "contacts.controls.show_all": "Tüm kişileri göster",
  "common.navigation": "Navigasyon",
  "common.favorite": "Favori",
  "common.block": "Engellemek",
  "common.user": "Kullanıcı",
  "common.avatar": "avatar",
  "message.new": "yeni mesaj",
  "message.edit": "Mesajı düzenle",
  "message.edit.save": "Düzenlemeyi kaydet",
  "message.edit.cancel": "Düzenlemeyi iptal et",
  'message.translating': 'Çevriliyor...',
  'message.translation_failed': 'Çevrilemedi',
  'message.not_translated': 'Orijinal metin',
  'message.retry_send': 'Yeniden dene',
  'message.retrying': 'Yeniden deneniyor...',
  "message.delete": "Mesajı sil",
  "message.deleted_placeholder": "Silinen mesaj",
  "message.edited": "Düzenlendi",
  "message.edited_at": "Düzenlenme tarihi",
  'message.delete_for_me.tooltip': 'Benim için sil',
  'message.delete_for_me.aria': 'Bu mesajı yalnızca benim için sil',
  'message.delete_for_me.confirm_title': 'Mesajı sil',
  'message.delete_for_me.confirm_message': 'Bu mesaj yalnızca sizin görünümünüzden silinecek.',
  'message.delete_for_everyone.tooltip': 'Herkes için sil',
  'message.delete_for_everyone.aria': 'Bu mesajı tüm katılımcılar için sil',
  'message.delete_for_everyone.confirm_title': 'Mesajı herkes için sil',
  'message.delete_for_everyone.confirm_message': 'Bu mesaj sizin ve diğer katılımcı için silinecek.',
  'message.delete_for_everyone.window_expired': 'Silme süresi doldu',
  "message.translation.show": "Orijinali ve çeviriyi görün",
  "message.translation.hide": "Çeviriyi gizle",
  "emoji.search": "Emoji ara",
  "emoji.close": "Seçiciyi kapat",
  "captcha.refresh": "CAPTCHA'yı yeniden oluştur",
  "home.access_nav": "Uygulamaya erişim",
  "common.requiredFields": "Gerekli tüm alanları doldurun.",
  "bio.view": "Biyografiye bakın",
  "profile.founderBadge": "Kurucu #{position}/{limit}",
  "profile.founderTooltip": "Kurucu Üye – Abonelik aktif kaldığı sürece fiyat ömür boyu dondurulur",
  "profile.founderMember": "Kurucu Üye",
  'profile.founderHeaderBadge': '★ Kurucu #{position}/150',
  'profile.camera.access_denied': 'Kameraya erişilemedi. İzinleri kontrol edin.',
  "profile.save.success": "Profiliniz başarıyla güncellendi.",
  "profile.save.success.title": "Güncellenmiş Profil",
  "profile.update.success.title": "Güncellenmiş Profil",
  "profile.update.success.message": "Değişiklikleriniz başarıyla kaydedildi.",
  "profile.save.error": "Profil güncellenemedi. Lütfen tekrar deneyin.",
  "profile.save.error.title": "Hatayı Kaydet",
  "profile.nick": "Kullanıcı adı",
  "profile.nick.help": "Sistemdeki benzersiz tanımlayıcınız",
  "profile.nick.readonly": "Kullanıcı adı değiştirilemez",
  "profile.nick.readonly.help": "Kullanıcı adı benzersizdir ve değiştirilemez",
  "profile.email.readonly": "E-posta değiştirilemez",
  "profile.email.readonly.help": "E-posta benzersizdir ve değiştirilemez",
  "profile.name": "Gerçek Ad",
  "profile.lastname": "Soy isim",
  "profile.alias": "Takma ad",
  "profile.email": "E-posta",
  "profile.phone": "Telefon",
  "profile.country": "Ülke",
  "profile.country.select": "Ülke seçin",
  "profile.biography": "Biyografi",
  'bio.modal.original': 'Orijinal',
  'bio.modal.translation': 'Çeviri',
  'bio.modal.empty': 'Bu kişinin biyografisi yok.',
  'bio.modal.translating': 'Çevriliyor...',
  'bio.modal.translation_error': 'Biyografi çevrilemedi.',
  'attachment.unnamed_file': 'Dosya',
  'auth.login_error.default_title': 'Erişim hatası',
  'auth.login_error.default_message': 'Giriş yapılamadı.',
  "profile.photo": "Profil Fotoğrafı",
                'notifications.bell.aria': 'Bildirimler',
                'notifications.panel.title': 'Bildirimler',
                'notifications.empty': 'Bildirim yok',
                'notifications.mark_read': 'Açınca okundu işaretle',
  'profile.notifications.sound': 'Notification sound',
  "profile.notifications.sound_desc": "Önemli mesajlar veya uyarılar geldiğinde ses çal",
  "profile.invitations.title": "Davetiyeler",
  "profile.invitations.validated": "Doğrulanmış davetiyeler",
  "profile.invitations.nextBadge": "Sonraki başarı",
  "profile.invitations.progress": "İlerlemek",
  "profile.invitations.achievement": "Başarı",
  "profile.invitations.topInviterAchieved": "Maksimum Davetçiye ulaşıldı",
  "profile.invitations.badges.networkBuilder": "Ağ Oluşturucu",
  "profile.invitations.badges.topInviter": "Maksimum Davetçi",
  "profile.invitations.achievement.networkBuilderMessage": "ArChat'e 20 kullanıcıyı davet ettiniz.",
  "profile.invitations.achievement.topInviterMessage": "ArChat'e 50 kullanıcıyı davet ettiniz.",
  "profile.plan.title": "Abonelik Planı",
  "profile.plan.current": "Mevcut Planınız",
  "profile.plan.expires": "süresi doluyor",
  "profile.plan.loading_info": "Plan bilgileri yükleniyor...",
  "profile.plan.valid_until": "Şu tarihe kadar geçerlidir:",
  "profile.plan.active_since": "Şu tarihten beri aktif:",
  "profile.plan.active_badge": "✓ Aktif",
  'profile.plan.free.description': 'Free plan with limitations. Upgrade to PRO for full access.',
  'profile.plan.pro.description': 'You have full access to all features.',
  "profile.plan.upgrade.button": "PRO'ya yükseltme",
  'profile.plan.upgrade.hint': 'Access all features without limits',
  "profile.manage_plan": "Planı yönet",
  "plan.current_plan": "Mevcut plan",
  "plan.current": "Actual",
  "plan.footer_prefix": "Plan:",
  "plan.upgrade_to_pro": "PRO'ya yükseltme",
  "plan.upgrade_to_foundation": "FOUNDATION'a yükseltme",
  "plan.payment_coming": "Paddle ile ödeme yakında kullanıma sunulacak. Planları buradan değiştirebilirsiniz.",
  "plan.payment_coming_title": "Yakında",
  "plan.foundation_full": "VAKIF kontenjanı dolmuştur (150 kurucu). PRO'yu seçebilirsiniz.",
  "plan.sold_out": "Yorgun",
  "plan.founder_spots_remaining": "Yalnızca {count} yer mevcut",
  "plan.founders_occupied": "meşgul kurucular",
  "plan.upgrade_not_allowed": "Yalnızca ÜCRETSİZ planı olan kullanıcılar yükseltme talebinde bulunabilir.",
  "plan.free_contacts": "Hasta 2 contactos",
  "plan.free_no_files": "Sin archivos",
  "plan.free_retention": "Historial 30 días",
  "plan.free_characters_month": "30,000 characters / month",
  "plan.pro_characters_month": "300,000 characters / month",
  "plan.pro_files": "Archivos hasta 50MB",
  "plan.pro_export": "Exportación",
  "plan.founder_support": "Prioridad soporte",
  "plan.founder_badge": "Badge fundador",
  "founder.title": "VAKIF (Kurucu)",
  "founder.subtitle": "Ömür boyu bedelle projeye başından itibaren destek oluyorsunuz.",
  "founder.whatIs": "İlk 150 kullanıcı FOUNDATION planını ömür boyu indirimli fiyatla alır.",
  "founder.howItWorks": "Kurucu seviyeniz pozisyonunuza bağlıdır (1 ila 150).",
  "founder.benefitsTitle": "Faydalar",
  'founder.benefitPrice': '$15 / ay (Founder ücreti)',
  "founder.benefitFeatures": "PRO planının tüm özelliklerini içerir.",
  "founder.limit": "Yalnızca 150 Kurucu yeri var.",
  "founder.cancelRule": "İptal ederseniz aboneliğinizi iptal ederken Kurucu statüsünü kaybedersiniz.",
  "founder.rejoinRule": "Tekrar kullanılabilir alan varsa, onu yeniden etkinleştirebilir ve otomatik olarak tekrar Kurucu olabilirsiniz.",
  "founder.tiers.title": "Kurucu Seviyeleri",
  "founder.tiers.legendary.name": "EFSANEVİ Kurucu",
  "founder.tiers.legendary.range": "Konum 1-25",
  "founder.tiers.legendary.desc": "Projeye ilk destek verenlerden. Maksimum tarihsel öncelik.",
  "founder.tiers.early.name": "EARLY Kurucusu",
  "founder.tiers.early.range": "Pozisyon 26–75",
  "founder.tiers.early.desc": "Özel tanınma ile erken destek.",
  "founder.tiers.founder.name": "kurucu",
  "founder.tiers.founder.range": "Pozisyon 76–150",
  "founder.tiers.founder.desc": "150 yer dahilinde kurucu kotası.",
  "founder.whatIsLink": "Kurucu Nedir?",
  "founder.viewTiers": "Kurucu seviyelerini görün",
  'billing.change_plan': 'Planı değiştir',
  "billing.usage.title": "Kullanım planı",
  "billing.usage.users": "Kullanıcılar",
  "billing.usage.messages": "Mesajlar (bugün)",
  "billing.usage.invitations": "Davetiyeler (bugün)",
  "billing.usage.messages_month": "Bu ayki mesajlar",
  "billing.usage.chats": "Konuşmalar",
  "billing.usage.contacts": "Kişiler",
  "billing.usage.chars_month": "Aylık karakter",
  "billing.usage.storage": "Kullanılan depolama",
  "billing.usage.devices": "Bağlı cihazlar",
  'billing.usage.warning': 'You are approaching your plan limit. Upgrade to PRO for more capacity.',
  'plans.limit.reached': 'Limit aşıldı — Plan yükselt',
  "billing.loading": "Şarj oluyor...",
  'billing.subscription.section_title': 'Abonelik ve faturalama',
  'billing.subscription.provider_note': 'Sağlayıcı',
  'billing.subscription.paddle_active': 'Paddle (uygulamada etkin plan)',
  'billing.subscription.mp_action_ok': 'İstek kaydedildi. Ödeme açılmadıysa bağlantıyı kontrol edin veya yeniden deneyin.',
  'billing.paddle.manage_subscription_button': 'Aboneliği yönet',
  'billing.paddle.portal_confirm_title': 'Faturalama portalı',
  'billing.paddle.portal_confirm': 'Ödeme yöntemi, faturalar veya abonelik iptali için güvenli Paddle portalı açılacak. Devam edilsin mi?',
  'billing.paddle.portal_opened_hint': 'Paddle portalı yeni sekmede açıldı. Plan güncellenmediyse profili yenileyin.',
  'billing.paddle.portal_error': 'Paddle portalı açılamadı. Daha sonra deneyin veya destekle iletişime geçin.',
  'billing.paddle.no_link_error': 'Hesabınızda henüz Paddle abonelik bağlantısı yok. Az önce ödediyseniz webhook bekleyin veya destekle iletişime geçin.',
  'billing.paddle.api_not_configured': 'Sunucuda Paddle API yapılandırması (PADDLE_API_KEY) eksik. Yönetici tanımlamalıdır.',
  "billing.descriptions.contacts": "Hesabınızda saklanan toplam kişi sayısı",
  "billing.descriptions.storage": "Dosyalar ve medya için kullanılan depolama",
  "billing.descriptions.chars_month": "Bu ay çevrilen karakterler",
  "billing.descriptions.devices": "Aktif bağlı cihazlar",
  'billing.paddle.return_title': 'Ödeme alındı',
  'billing.paddle.return_body': 'Ödemeyi tamamladıysanız, Paddle onayından kısa süre sonra planınız güncellenir. Ana sayfaya dönebilirsiniz.',
  'billing.paddle.verifying': 'Planınız kontrol ediliyor…',
  'billing.paddle.not_logged_in': 'Güncel plan durumunu görmek için giriş yapın.',
  'billing.paddle.plan_updated': 'Plan güncellendi: {plan}',
  'billing.paddle.plan_current': 'Mevcut planınız: {plan}',
  'billing.paddle.plan_current_founder': 'Artık Founder oldunuz — {plan}',
  'billing.paddle.still_free_hint': 'Bir süre sonra hâlâ FREE görüyorsanız webhook gecikmiş olabilir. Backend günlüklerini kontrol edin veya sayfayı yenileyin.',
  'billing.paddle.pro_extra_hint': 'Planınızı kullanmak için ana sayfaya dönebilirsiniz.',
  "profile.theme.dark": "Karanlık Mod",
  "profile.theme.light": "Temizleme Modu",
  "profile.theme.argentina": "Arjantin Teması",
  "modal.title": "Vasıf",
  "modal.success.title": "Başarı",
  "modal.error.title": "Hata",
  "modal.warning.title": "Uyarı",
  "info.title": "Bilgi",
  "appearance.title": "Dış görünüş",
  "appearance.theme.light": "Temizlemek",
  "appearance.theme.dark": "Karanlık",
  "theme.title": "Sorun",
  "theme.light": "Temizlemek",
  "theme.dark": "Karanlık",
  "profile.photo.section": "Profil Fotoğrafı",
  "profile.personalInfo": "Kişisel Bilgiler",
  "profile.preferences": "Tercihler",
  "profile.country.help": "Saat dilimi seçilen ülkeye göre otomatik olarak atanacaktır",
  "profile.lastname.placeholder": "Soyadınız (isteğe bağlı)",
  "profile.name.placeholder": "Gerçek adınız (isteğe bağlı)",
  "profile.biography.placeholder": "Bize kendinizden bahsedin...",
  "profile.photo.change": "Profil fotoğrafını değiştir",
  "message.placeholder": "Bir mesaj yazın...",
  "message.placeholderWithFile": "Dosyayı gönder",
  "message.sent_from_country": "Gönderildi",
  "message.sent_at_local_time": "Vericinin yerel saati",
  "message.timezone_label": "saat dilimi",
  "message.context_info": "Bu mesaj gönderildiği zamanın zaman bağlamını korur.",
  "message.context_pro_hint": "Bu mesajın Pro planlarında zaman ve coğrafi bağlam mevcuttur.",
  "message.context_pro_badge": "Bağlam Profesyoneli",
  "messages.empty": "Henüz mesaj yok",
  "messages.loading": "Mesajlar yükleniyor...",
  "messages.connecting_server": "Mesaj sunucusuna bağlanılıyor...",
  "messages.pending_send_count": "{count} mesaj teslim edilmeyi bekliyor",
  "attachment.title": "Dosya Ekle",
  "attachment.close": "Kapalı",
  "attachment.gallery": "Fotoğraf/video galerisi",
  "attachment.cameraFront": "ön kamera",
  "attachment.cameraBack": "arka kamera",
  "attachment.cameraWeb": "web kamerası",
  "attachment.selectFile": "Dosya seçin (PDF, metin, resimler, videolar)",
  "attachment.remove": "Elemek",
  'attachments.recipientFreeBlocked.title': 'Plan limiti',
  'attachments.recipientFreeBlocked.sender': 'Bu kullanıcının Free planı var; ek dosya alamaz.',
  'attachments.recipientFreeBlocked.receiver': '{senderName} size ek göndermeye çalıştı, ancak {planName} planınız ekleri kabul etmiyor. Dosya almak için daha üst bir plan önerilir.',
  'attachments.recipientFreeBlocked.upgradeCta': 'Planı yükselt',
  "attachment.audioNotSupported": "ArChat®'te sesli mesajlar desteklenmez. Lütfen yazılı mesaj gönderin.",
  "message.audioDeprecated.title": "Sesli mesaj desteklenmiyor",
  "message.audioDeprecated.message": "Bu sesli mesaj artık ArChat® tarafından desteklenmemektedir. Lütfen yazılı mesaj gönderin.",
  "camera.title": "Kamera",
  "camera.close": "Kapalı",
  "camera.switch": "Kamerayı değiştir",
  "camera.capture": "Fotoğraf Çek",
  "camera.loading": "Kamera başlatılıyor...",
  "camera.retry": "Yeniden dene",
  "camera.error.access": "Kameraya erişilemedi. İzinleri kontrol edin.",
  "camera.error.permission": "Kamera izinleri reddedildi. Lütfen tarayıcı ayarlarınızdan kameraya erişime izin verin.",
  "camera.error.notFound": "Kullanılabilir kamera bulunamadı.",
  "camera.error.busy": "Kamera başka bir uygulama tarafından kullanılıyor.",
  "camera.error.constraint": "Kamera kısıtlamaları karşılanamaz.",
  "profile.photo.take": "Fotoğraf çek",
  "profile.photo.gallery": "Galeriden seç",
  "profile.photo.select": "Fotoğraf seç",
  "profile.photo.select.gallery": "Galeriden seç",
  "profile.photo.uploading": "Resim yükleniyor...",
  "profile.photo.upload.success": "Profil fotoğrafı başarıyla güncellendi",
  "profile.photo.upload.success.title": "Fotoğraf Güncellendi",
  "profile.photo.upload.error": "Profil fotoğrafı yüklenirken hata oluştu. Lütfen tekrar deneyin.",
  "profile.photo.upload.error.title": "Fotoğraf yüklenirken hata oluştu",
  "avatar.errors.too_large": "Resim çok büyük. Maksimum boyut: 2 MB.",
  "avatar.preview.title": "Avatar Önizlemesi",
  "profile.avatar.error_title": "Avatar güncellenemedi",
  "profile.avatar.error.title": "Avatar güncellenemedi",
  "profile.avatar.error.size": "Resim izin verilen boyutu aşıyor. Maksimum 2 MB'tır.",
  "profile.avatar.tooLarge.title": "Resim çok büyük",
  "profile.avatar.tooLarge.message": "Fotoğraf izin verilen boyutu aşıyor. Maksimum 2 MB'tır.",
  "profile.avatar.uploadError.title": "Avatar güncellenemedi",
  "profile.avatar.uploadError.message": "Resim yüklenirken bir sorun oluştu. Tekrar deneyin.",
  "profile.saveSuccess.title": "Profil güncellendi",
  "profile.saveSuccess.message": "Değişiklikleriniz başarıyla kaydedildi.",
  "profile.avatar.file_too_large": "Resim izin verilen maksimum boyutu (2 MB) aşıyor.",
  "profile.avatar.file_too_large_hint": "Daha hafif bir resim seçin veya boyutunu küçültüp tekrar deneyin.",
  "profile.photo.take.front": "ön kamera",
  "profile.photo.take.back": "arka kamera",
  "profile.photo.take.webcam": "web kamerası",
  "profile.photo.camera.front": "ön kamera",
  "profile.photo.camera.back": "arka kamera",
  "profile.photo.camera.web": "web kamerası",
  "profile.photo.close": "Kapalı",
  "profile.photo.capture": "Esir almak",
  "user.default": "Kullanıcı",
  "logout.title": "Onaylamak",
  "logout.confirm": "Oturumu kapatmak istediğinizden emin misiniz?",
  "block.toggle_error": "Kilitlenemedi veya kilidi açılamadı.",
  "contacts.search.placeholder": "Kullanıcı adı, ad, soyadı, ülke veya dile göre arama yapın...",
  "contacts.empty": "Hiç kişi yok",
  "contacts.empty.private.message": "Profiliniz gizli. Kişileri sohbete başlamaya davet edin.",
  "contacts.empty.private.invite_button": "Bir kişiyi davet edin",
  "contacts.search.no_results": "Kişi bulunamadı",
  "contacts.search.clear": "Tümünü göster",
  "contacts.nick": "Kullanıcı adı",
  "contacts.name": "İsim",
  "contacts.lastname": "Soy isim",
  "contacts.country": "Ülke",
  "contacts.language": "Dil",
  "contacts.status": "Durum",
  "contacts.status.pending_registration": "Kayıt bekleniyor",
  "contacts.status.registered": "Misafir - Kayıtlı",
  "contacts.status.ready_to_chat": "Sohbete hazır",
  "contacts.status.active_conversation": "Aktif konuşma",
  "contacts.invitation.pending.title": "Bekleyen Davet",
  "contacts.invitation.pending.message": "Bu davetiyenin kaydı bekleniyor. Kişi, kaydını tamamlamak için bir e-posta alacaktır. Kayıt olduktan sonra onunla sohbet edebileceksiniz.",
  "contacts.error.no_registered": "Kişi henüz kayıtlı değil. Kaydınızın tamamlanmasını bekleyin.",
  "contact.edit.title": "Kişiyi Düzenle",
  "contact.edit.alias.label": "Özel takma ad",
  "contact.edit.alias.placeholder": "Örn: Juan işten",
  "contact.edit.alias.help": "Gerçek adın yerine bu ad görünecek",
  "contact.edit.nota.label": "Kişisel not",
  "contact.edit.nota.placeholder": "Bu kişi hakkında bir not ekleyin...",
  "contact.edit.nota.help": "Yalnızca sizin görebileceğiniz özel notlar",
  "contact.edit.error.noUser": "Hata: Tanımlanamayan kullanıcı",
  "contact.edit.error.noContactId": "Hata: Kişi tanımlanamadı",
  "contact.edit.error.save": "Kaydedilirken hata oluştu",
  "contact.limit.title": "İletişim sınırına ulaşıldı",
  "contact.limit.message": "ÜCRETSİZ plan kullanıcı başına en fazla 2 kişiye izin verir. Şarj etme etkinleştirildiğinde daha fazla kapasite için FOUNDATION veya PRO'ya yükseltebilirsiniz.",
  "contact.favorite.add": "Favorilere ekle",
  "contact.favorite.remove": "Favorilerden kaldır",
  "contact.block.block": "Engellemek",
  'contact.block.unblock': 'Engeli kaldır',
  "conversation.backToContacts": "Kişilere dön",
  "conversation.notFound": "Konuşma bulunamadı",
  "help.howWorks.step1.title": "1️⃣ Kayıt",
  "help.howWorks.step1.point1": "Kullanıcı adınız ve şifrenizle giriş yapın.",
  "help.howWorks.step1.point2": "Hesabınız yoksa otomatik olarak oluşturulur.",
  "help.howWorks.step1.point3": "Kendi dilinizdeki Şartlar ve Koşulları kabul edersiniz.",
  "help.howWorks.step1.point4": "Hesabınızı e-postayla onaylıyorsunuz.",
  "help.howWorks.step2.title": "2️⃣ Özel davetiyeler",
  "help.howWorks.step2.point1": "Kişilerinizi profilinizden e-postayla davet edin.",
  "help.howWorks.step2.point2": "Başlamadan önce dili ve konuşma modunu tanımlayın.",
  "help.howWorks.step2.point3": "Kişi özel bir davet alır.",
  "help.howWorks.step2.point4": "Durumun şu şekilde olup olmadığını görebilirsiniz: Beklemede, Kayıtlı, Sohbete hazır",
  "help.howWorks.step2.point5": "Temas aranmaz, davet edilir.",
  "help.howWorks.step2.point6": "Temas aranmaz, davet edilir.",
  "help.howWorks.step3.title": "3️⃣ Kişiler ve konuşmalar",
  "help.howWorks.step3.point1": "Kişileriniz şu durumlarda otomatik olarak görünür:",
  "help.howWorks.step3.point2": "bir daveti kabul et",
  "help.howWorks.step3.point3": "ya da bir konuşma var",
  "help.howWorks.step3.point4": "Olabilmek:",
  "help.howWorks.step3.point5": "onları favori olarak işaretle ⭐",
  "help.howWorks.step3.point6": "onlara özel takma adlar atayın",
  "help.howWorks.step3.point7": "özel notlar ekle",
  "help.howWorks.step3.point8": "bunları engelleyin veya yönetin",
  "help.howWorks.step3.point9": "Rızası olmayan hiçbir kamu gündemi veya görünür kullanıcı yoktur.",
  "help.howWorks.step4.title": "4️⃣ Çeviri ile mesajlaşma",
  "help.howWorks.step4.point1": "Her zaman kendi dilinizde yazın.",
  "help.howWorks.step4.point2": "Sistem mesajı otomatik olarak çevirir.",
  "help.howWorks.step4.point3": "Alıcı bunu kendi dilinde alır.",
  "help.howWorks.step4.point4": "Uygulanan çeviriyi görebilirsiniz.",
  "help.howWorks.step4.point5": "Bir çeviri başarısız olursa otomatik olarak yeniden denenir.",
  "help.howWorks.step4.point6": "ArChat® yalnızca hıza değil, açıklığa ve anlama da öncelik verir.",
  "help.privacy.title": "🔒 Gizlilik ve kontrol",
  "help.privacy.point1": "Profiliniz varsayılan olarak gizlidir.",
  "help.privacy.point2": "Yalnızca davet ettiğiniz kişiler sizi görebilir veya size yazabilir.",
  "help.privacy.point3": "Herkese açık görünürlük isteğe bağlıdır ve varsayılan olarak devre dışıdır.",
  "help.privacy.point4": "Aşağıdakilerle aktif güvenlik:",
  "help.privacy.point5": "CAPTCHA",
  "help.privacy.point6": "hız sınırlaması",
  "help.privacy.point7": "parmak izi",
  "help.privacy.point8": "e-posta doğrulaması",
  "help.privacy.point9": "Görüşmeleriniz herkese açık veya dizine eklenmemiş.",
  "help.files.title": "📎 Dosyalar ve dışa aktarma",
  "help.files.point1": "Resimler, videolar ve PDF belgeleri ekleyin.",
  "help.files.point2": "Ön kamera, arka kamera veya web kamerasıyla fotoğraf çekin.",
  "help.files.point3": "Görüntüler otomatik olarak sıkıştırılır.",
  "help.files.point4": "Göndermeden önce önizleyin.",
  "help.files.point5": "Yükleme sırasında ilerleme çubuğu.",
  "help.files.point6": "Konuşmaların tamamını şuraya aktar:",
  "help.files.point7": "PDF'ler",
  "help.files.point8": "Html",
  "help.files.point9": "Mesajları, resimleri ve dosyaları içerir.",
  "help.files.point10": "Verileriniz sizindir.",
  "help.experience.title": "🎨 Kullanıcı deneyimi",
  "help.experience.point1": "Emojili iletişim durumları ve özel durumlar.",
  "help.experience.point2": "Entegre OpenMoji emojileri.",
  "help.experience.point3": "Göstergeleri okuyun ve yazın.",
  "help.experience.point4": "Masaüstüne eşit optimize edilmiş mobil görünüm.",
  "help.experience.point5": "Yüklenebilir PWA uygulaması.",
  "help.experience.point6": "İki tema: Arjantin (açık mavi/beyaz/altın) ve Oscuro (koyu mor).",
  "help.experience.point7": "Alkolsüz içecekler olmadan profil düzenleme.",
  "help.experience.point8": "Otomatik saat dilimine sahip ülke seçici.",
  "help.experience.point9": "Favoriler, arama ve filtrelerle hızlı erişim.",
  "help.languages.point3": "Arayüz, Şartlar ve Koşullar ve seçilen dile uyarlanmış e-postalar.",
  "help.languages.point4": "Kullanıcılar arasında iki yönlü otomatik çeviri.",
  "help.tipsNew.title": "💡 ArChat®'ten yararlanmaya yönelik ipuçları",
  "help.tipsNew.point1": "Yalnızca gerçekten iletişim kurmak istediğiniz kişileri davet edin.",
  "help.tipsNew.point2": "Kişileri düzenlemek için takma adları ve özel notları kullanın.",
  "help.tipsNew.point3": "Hızlı erişim için favorileri işaretleyin.",
  "help.tipsNew.point4": "Önemli mesajları göndermeden önce çeviriyi kontrol edin.",
  "help.tipsNew.point5": "Yedekleme veya iş için ilgili konuşmaları dışa aktarın.",
  "help.tipsNew.point6": "Yazılı netliğin önemli olduğu durumlarda ArChat® kullanın.",
  "help.whySubscribe.title": "🚀 Neden ArChat®'e abone olmalısınız?",
  "help.whySubscribe.point1": "ArChat® herhangi biriyle sohbet etmek için tasarlanmamıştır,",
  "help.whySubscribe.point2": "ama önemli olanlarla daha iyi iletişim kurmak için.",
  "help.whySubscribe.point3": "İhtiyacınız varsa:",
  "help.whySubscribe.point4": "diller arasındaki netlik",
  "help.whySubscribe.point5": "gerçek gizlilik",
  "help.whySubscribe.point6": "kontak kontrolü",
  "help.whySubscribe.point7": "görüşmeyi dışa aktarma",
  "help.whySubscribe.point8": "profesyonel ve gürültüsüz bir deneyim",
  "help.whySubscribe.point9": "ArChat® bunun için tasarlanmıştır.",
  "help.how.step1.description": "Erişmek için takma adınızı ve şifrenizi kullanın. Hesabınız yoksa otomatik olarak oluşturulur.",
  "help.how.step2.title": "Kişinizi davet edin",
  "help.how.step2.description": "Profilinizden e-postayla davet edin ve konuşmanın dilini ve modunu tanımlayın.",
  "help.how.step3.title": "Kendi dilinizde yazın",
  "help.how.step3.description": "Tercih ettiğiniz dilde yazın ve ArChat® mesajınızı otomatik olarak çevirsin.",
  "help.how.step4.title": "Alıcı bunu çevrilmiş olarak alır",
  "help.how.step4.description": "Karşı taraf mesajı kendi diline çevrilmiş şekilde bağlam ve netlikle alır.",
  "help.features.title": "Ana özellikler",
  "help.features.translation": "🌐 Diller arasında otomatik ve anında çeviri",
  "help.features.status": "💬 Durum Durumları (Çevrimiçi, Boşta, Rahatsız Etmeyin vb.)",
  "help.features.statusCustom": "💬 Emoji ve kişiselleştirilmiş mesaj içeren özel durumlar",
  "help.features.contacts": "👥 Sabitlenmiş favorilere (üstte) ve Kullanıcılar modundan yönetilebilen bloklara sahip kişilerin tam listesi",
  "help.features.contactsMobile": "📱 Üst çubukta durum ve görünüm ile optimize edilmiş mobil görünüm (PC ile aynı)",
  "help.features.contactsFilter": "👁️ Favori olmayan kişileri göster/gizle düğmesi - listeyi yalnızca favorilerinize azaltın",
  "help.features.contactAlias": "✏️ Her kişi için özel takma ad ve özel notlar - görüşmedeki kişi adına tıklayın",
  "help.features.themes": "🎨 İki tema mevcuttur: Arjantin (açık mavi/beyaz/altın) ve Oscuro (koyu mor)",
  "help.features.messages": "📨 Okuma göstergeleri, satır içi OpenMoji emojileri ve görünür yazmayla gerçek zamanlı mesajlaşma",
  "help.features.attachments": "📎 Yazılı iletişime uygun dosyalar ekleyin: resimler, videolar ve PDF belgeleri",
  "help.features.camera": "📸 Ön, arka veya web kamerasıyla fotoğraf çekin",
  "help.features.gallery": "🖼️ Galeriden dosya seçimi",
  "help.features.compression": "🗜️ Otomatik görüntü sıkıştırma ve küçük resim oluşturma",
  "help.features.progress": "📊 Dosya yükleme sırasında ilerleme çubuğu",
  "help.features.delete": "🗑️ Kendi mesajlarının silinmesi",
  "help.features.scroll": "⬇️ Bir görüşmeyi açarken son mesaja otomatik kaydırma",
  "help.features.profile": "👤 Avatar, biyografi ve tercihlerle özelleştirilebilir profil",
  "help.features.profileEdit": "✏️ Sorunsuz profil düzenleme (düzenleme sırasında yenilenmez)",
  "help.features.countries": "🌍 Otomatik saat dilimi seçimiyle 195'ten fazla ülkenin tam listesi",
  "help.features.registration": "📧 Hesap oluşturmadan ve e-posta onayı almadan önce zorunlu Şartlar ve Koşullar ile kayıt olun",
  "help.features.multilanguage": "🗣️ Bayraklı {count} dil desteği; Şartlar ve Koşullar ve seçilen dile çevrilmiş e-postalar",
  "help.features.pwa": "📲 Mobil cihazlara ve masaüstüne kurulabilen PWA uygulaması",
  "help.features.sync": "🔄 Her 5 saniyede bir otomatik mesaj senkronizasyonu",
  "help.features.deleteSync": "🗑️ Silinen mesajların cihazlar arasında otomatik senkronizasyonu",
  "help.features.notifications": "🔔 Alınan yeni mesajlar için sesli bildirimler",
  "help.features.retranslation": "🔄 İlk seferde başarısız olursa mesajların otomatik olarak yeniden çevrilmesi",
  "help.features.preview": "👁️ Dosyaları göndermeden önce önizleyin",
  "help.features.security": "🔒 CAPTCHA, parmak izi, hız sınırlama ve zorunlu Şartlar ve Koşullar akışına sahip güvenlik sistemi",
  "help.features.passwordRecovery": "🔑 E-postayla şifre kurtarma",
  "help.features.emailConfirmation": "📧 Aktivasyon bağlantısını içeren e-posta yoluyla hesap onayı",
  "help.features.invitations": "📧 Özel e-posta davetiyeleri - Tanımlı dil ve bağlamla harici kişileri davet edin",
  "help.features.invitationsManagement": "📋 Komple davetiye yönetimi - Menüden bekleyen davetiyeleri listeleyin, yeniden gönderin veya iptal edin",
  "help.features.contactStatus": "🏷️ Görünür kişi durumları - Her kişinin durumunu görün (beklemede, kayıtlı, sohbete hazır)",
  "help.features.favorites": "⭐ Favoriler Sistemi - Hızlı erişim için kişileri favori olarak işaretleyin",
  "help.features.profilePhoto": "📸 Geliştirilmiş Profil Fotoğrafı Yükleme – Anında önizlemeyle galeriden görsel seçin",
  "help.features.translationSender": "👁️ Gönderenin çevirilerini görüntüleyin - Mesajınızın alıcının diline nasıl çevrildiğini görün",
  "help.features.unifiedContacts": "🔗 Birleşik iletişim modeli - Kişiler mevcut davetlerden ve konuşmalardan elde edilir",
  "help.features.privacy": "🔒 Varsayılan olarak özel mod - Profiliniz özeldir ve yalnızca doğrudan davetle erişilebilir",
  "help.features.export": "💾 Konuşma Dışa Aktarma - Konuşmaların tamamını resim ve dosyalarla birlikte PDF veya HTML'ye aktarın",
  "help.tips.title": "Yararlı ipuçları",
  "help.tips.language": "✅ {count} bayrak seçiciyle dilinizi ayarlayın; Şartlar ve Koşullar ve e-postalar bu dilde görüntülenir",
  "help.tips.status": "✅ Başkalarının uygunluk durumunuzu bilmesi için iletişim durumunuzu güncelleyin",
  "help.tips.statusCustom": "✅ Mevcut durumunuzu ifade etmek için emoji ve mesajla özel durumlar oluşturun",
  "help.tips.search": "✅ Favorileri işaretleyin (yıldız) ve kullanıcıları \"Kullanıcılar\" modundan engelleyin",
  "help.tips.contactsFilter": "✅ Favori olmayan kişileri göstermek veya gizlemek için üst çubuktaki göz düğmesini (👁️) kullanın",
  "help.tips.contactAlias": "✅ Özel bir takma ad ve özel notlar eklemek için görüşmedeki kişi adına tıklayın",
  "help.tips.avatar": "✅ Resmini daha büyük görmek için kişinin avatarına tıklayın",
  "help.tips.messages": "✅ Okunmamış mesajlarınız olduğunda ArChat® simgesi yanıp söner; OpenMoji başlatıcısıyla emoji ekleyin",
  "help.tips.attachments": "✅ Klip düğmesini (📎) kullanarak resimler, videolar veya PDF'ler ekleyin; yazılı iletişime uyumlu",
  "help.tips.camera": "✅ Doğrudan uygulamadan fotoğraf çekmek için kamerayı kullanın",
  "help.tips.compression": "✅ Yerden tasarruf etmek için resimler otomatik olarak sıkıştırılır",
  "help.tips.delete": "✅Sil butonuna tıklayarak kendi mesajlarınızı silebilirsiniz.",
  "help.tips.profile": "✅ Profilinizi soda olmadan düzenleyin ve Arjantin / Koyu (açık veya koyu tema) arasında geçiş yapın.",
  "help.tips.themes": "✅ Temayı Ayarlar > Görünüm'den değiştirin: Arjantin (açık mavi) veya Koyu (koyu mor)",
  "help.tips.country": "✅ Saat diliminin otomatik olarak ayarlanması için profilde ülkenizi seçin",
  "help.message_time_context.title": "Mesajların zamansal bağlamı",
  "help.message_time_context.description": "Her mesaj, gönderenin gönderildiği andaki yerel saatini, saat dilimini ve ülkesini kaydedebilir. Bu sayede diğer kullanıcının nereye ve ne zaman mesaj gönderdiğini görebilirsiniz.",
  "help.message_time_context.point1": "ÜCRETSİZ planda yalnızca sizin saat diliminizdeki (alıcı) saat gösterilir.",
  "help.message_time_context.point2": "PRO planında, verenin yerel saati, ülkesi ve saat dilimi de gösterilir.",
  "help.message_time_context.point3": "Bağlam her mesajda tarihsel olarak kaydedilir.",
  "help.message_time_context.point4": "Gelişmiş denetim özellikleri daha yüksek planlarda mevcuttur.",
  "help.tips.registration": "✅ Kaydolmadan önce kendi dilinizdeki Şartlar ve Koşulları kabul edin; ardından hesabı etkinleştirmek için e-postanızı doğrulayın",
  "help.tips.writing": "✅ Anlaşılır mesajlar yazın: ArChat® yazılı metnin anlamını çevirir, bağlamı ve netliği korur",
  "help.tips.install": "✅ Hızlı masaüstü erişimi için ArChat®'i cihazınıza PWA uygulaması olarak yükleyin",
  "help.tips.sync": "✅ Mesajlar her 5 saniyede bir otomatik olarak senkronize edilir; yenilemeye gerek yoktur",
  "help.tips.deleteSync": "✅ Bir mesajı silerseniz, alıcının tüm cihazlarında otomatik olarak silinir",
  "help.tips.notifications": "✅ Başka bir kullanıcıdan yeni mesaj aldığınızda bir ses duyacaksınız",
  "help.tips.retranslation": "✅ Mesajın doğru tercüme edilmemesi durumunda sistem, mesajı otomatik olarak yeniden tercüme etmeye çalışacaktır.",
  "help.tips.preview": "✅ Doğru olduğundan emin olmak için göndermeden önce dosya önizlemesini kontrol edin",
  "help.tips.passwordRecovery": "✅ Şifrenizi unuttuysanız \"Şifrenizi mi unuttunuz?\" bağlantısını kullanın. girişte",
  "help.tips.emailConfirmation": "✅ Kayıt olduktan sonra e-postanızı kontrol edin ve onay bağlantısını tıklayın",
  "help.tips.languageChange": "✅ Bayrak seçiciden dilinizi değiştirin: Şartlar ve Koşullar, e-postalar ve kullanıcı arayüzü güncellemesi anında",
  "help.tips.inputFixed": "✅ PC'de yazma çubuğu daha fazla konfor için ekranın altına sabitlenmiştir",
  "help.tips.invitations": "✅ Profilinizden kişileri e-postayla davet edin - Dili ve konuşma modunu baştan tanımlayın",
  "help.tips.invitationsManagement": "✅ Davetiyelerinizi \"Gönderilen Davetiyeler\" menüsünden yönetin - E-postaları yeniden gönderin veya bekleyen davetiyeleri iptal edin",
  "help.tips.contactStatus": "✅ Listedeki her kişinin durumunu görün - Beklemede (turuncu), Kayıtlı (yeşil) veya Aktif görüşme (mavi)",
  "help.tips.favorites": "✅ Kişileri yıldızla favori olarak işaretleyin ⭐ - Favoriler listenizde ilk sırada görünür",
  "help.tips.profilePhoto": "✅ \"Galeriden seç\" bölümünden profil fotoğrafınızı yükleyin - Kaydetmeden önce bir önizleme göreceksiniz",
  "help.tips.translationSender": "✅ Bir mesaj gönderirken, mesajın alıcının diline nasıl çevrildiğini görmek için çeviri panelini genişletin",
  "help.tips.unifiedContacts": "✅ Kişileriniz davetleri kabul ettiklerinde veya kendileriyle konuştuklarında otomatik olarak gösterilir",
  "help.tips.privacy": "✅ Profiliniz varsayılan olarak gizlidir - Başkalarının sizi bulmasını istiyorsanız Profil > Gizlilik bölümünde genel görünürlüğü etkinleştirin",
  "help.tips.export": "✅ Başlıktaki ⬇️ düğmesini kullanarak tüm konuşmaları dışa aktarın - Tüm görselleri içeren PDF veya HTML'yi seçin",
  "help.support.title": "Orta",
  "help.support.description": "Sorunlarınız veya sorularınız varsa sistem yöneticinizle iletişime geçin veya mevcut teknik belgeleri inceleyin.",
  "help.about.title": "Hakkında",
  "help.about.developer": "Tarafından geliştirildi:",
  "help.about.location": "MDQ - ARJANTİN",
  "help.about.linkedin": "Profili LinkedIn'de görüntüle",
  "presence.custom.suggestion.coffee": "Bazı arkadaşlarım var ☕",
  "presence.custom.suggestion.soccer": "Sahada ⚽",
  "presence.custom.suggestion.working": "Deli gibi çalışıyorum 💪",
  "presence.custom.suggestion.lunch": "Öğle yemeği yiyoruz 🍽️",
  "presence.custom.suggestion.family": "Aile yemeği 👨‍👩‍👧‍👦",
  "presence.custom.suggestion.studying": "Çalışıyorum 📚",
  "presence.custom.suggestion.travel": "Bir gezide ✈️",
  "presence.custom.suggestion.meeting": "Toplantıda 💼",
  "presence.custom.suggestion.resting": "Dinleniyor 😴",
  "presence.custom.suggestion.gaming": "Video oyunları oynamak 🎮",
  "presence.custom.suggestion.reading": "Okumak 📖",
  "presence.custom.suggestion.offlineSoon": "Hemen döneceğim",
  "export.title": "Konuşmayı Dışa Aktar",
  "export.description": "Bu görüşmeyi dışa aktarmak istediğiniz biçimi seçin:",
  "export.progress": "Dışa aktarılıyor...",
  "export.format.pdf": "PDF'ler",
  "export.format.pdf.description": "Tüm resim ve dosyaları içeren PDF belgesi",
  "export.format.html": "Html",
  "export.format.html.description": "Herhangi bir tarayıcıda açabileceğiniz HTML dosyası",
  "export.info": "Dışa aktarma işlemi bu görüşmedeki tüm mesajları, resimleri ve dosyaları içerecektir.",
  "export.pro_required.title": "Görüşmeyi dışa aktar",
  "export.pro_required.message": "Bu özellik PRO planında mevcuttur.",
  "invitation.email.placeholder": "ejemplo@email.com",
  "invitation.success.message": "Davetiye başarıyla gönderildi.\\n\\nKişi, daveti kabul etmesini sağlayacak bağlantıyı içeren bir e-posta alacak. Kabul edildikten sonra onunla sohbet etmeye başlayabilirsiniz.",
  "invitation.error.self": "Kendini davet edemezsin",
  "invitation.error.duplicate": "Bu e-posta için zaten bekleyen bir davetiye var",
  "invitation.top.title": "En İyi Ağ Oluşturucular",
  "invitation.top.invitesSuffix": "davetiyeler",
  "invitation.safe.phase_notice": "Aktif güvenli aşama: Ticari aktivasyonu bekleyen faydalar (limitler üzerinde gerçek bir etki yoktur).",
  "invitation.safe.generate_code": "Bağlantı/kod oluştur",
  "invitation.safe.refresh_top3": "İlk 3'ü Güncelle",
  "invitation.safe.top_loading": "En iyi davetliler yükleniyor...",
  "invitation.safe.top_empty": "Henüz öne çıkan davetli yok.",
  "invitation.safe.hide_full_ranking": "Tam sıralamayı gizle",
  "invitation.safe.view_full_ranking": "Tam sıralamayı görün",
  "invitation.safe.hide_metrics_dashboard": "Metrik kontrol panelini gizle",
  "invitation.safe.view_metrics_dashboard": "Metrik kontrol panelini görüntüle",
  "invitation.safe.prepared_link": "Bağlantı hazırlandı",
  "invitation.safe.email_placeholder": "email@dominio.com",
  "invitation.safe.register_pending": "Bekleyen daveti kaydedin",
  "invitation.safe.status_summary": "Durum Özeti",
  "invitation.safe.summary.pending": "Küpeler",
  "invitation.safe.summary.registered": "Kayıtlı",
  "invitation.safe.summary.active": "Aktif",
  "invitation.safe.summary.validated": "Doğrulandı",
  "invitation.safe.summary.rejected": "Reddedilmiş",
  "invitation.safe.sent_invitations": "Davetiyeler verildi",
  "invitation.safe.table.id": "İD",
  "invitation.safe.table.invited_email": "Misafir E-postası",
  "invitation.safe.table.code": "Kod",
  "invitation.safe.table.status": "Durum",
  "invitation.safe.table.created": "Oluşturuldu",
  "invitation.safe.empty_sent": "Henüz davetiye yayınlanmadı.",
  "invitation.safe.simulated_rewards": "Kazanılan simüle edilmiş ödüller",
  "invitation.safe.empty_rewards": "Şimdilik simüle edilmiş ödül yok.",
  "invitation.safe.error.load_status": "Davetiye durumu yüklenemedi.",
  "invitation.safe.error.generate_code": "Kod oluşturulamadı.",
  "invitation.safe.error.invalid_email": "Davetiyeyi kaydetmek için geçerli bir e-posta girin.",
  "invitation.safe.error.register_pending": "Bekleyen davetiye kaydedilemedi.",
  "invitation.safe.success.code_generated": "Başarıyla kod oluşturuldu.",
  "invitation.safe.success.pending_registered": "Bekleyen davetiye güvenli modda kaydedildi.",
  "invitation.ranking.position": "Konum",
  "invitation.ranking.user": "Kullanıcı",
  "invitation.ranking.validatedInvites": "Doğrulanmış davetiyeler",
  "invitation.ranking.empty": "Görüntülenecek doğrulanmış davetiye yok.",
  "invitation.ranking.loading": "Sıralama yükleniyor...",
  "invitation.ranking.loadError": "Sıralama yüklenemedi.",
  "invitation.status.deleted": "elendi",
  "invitation.deleted.tooltip": "Bu davetiye kaldırıldı",
  "invitation.status.rejected": "Reddedilmiş",
  "invitation.status.bounced": "geri döndü",
  "invitation.status.unknown": "Bilinmeyen durum",
  "invitation.copy.link": "Bağlantıyı kopyala",
  "invitation.copy.success": "Bağlantı panoya kopyalandı",
  "invitation.accept.title": "Daveti Kabul Et",
  "invitation.accept.description": "ArChat®'te sohbete davet edildiniz",
  "invitation.accept.inviter": "Davet eden:",
  "invitation.accept.message": "kişisel mesaj",
  "invitation.accept.login": "Giriş yapmak",
  "invitation.accept.register": "Kayıt olmak",
  "invitation.accept.error.invalid": "Geçersiz davetiye jetonu",
  "invitation.accept.error.expired": "Bu davetiyenin süresi doldu",
  "invitation.accept.error.accepted": "Bu davet zaten kabul edildi",
  "invitation.accept.error.cancelled": "Bu davet iptal edildi",
  "invitation.accept.error.email_mismatch": "Hesap e-postanız davet e-postasıyla eşleşmiyor",
  "invitation.accept.success": "Davet kabul edildi. Sohbete yönlendiriliyorsunuz...",
  "invitations.sent.title": "Davetiyeler gönderildi",
  "invitations.sent.empty": "Bekleyen davetiye yok",
  "invitations.pending.title": "Bekleyen davetiyeler",
  "invitations.columns.email": "E-posta",
  "invitations.columns.language": "Dil",
  "invitations.columns.mode": "Mod",
  "invitations.columns.status": "Durum",
  "invitations.columns.sentAt": "Gönderilmiş",
  "invitations.columns.actions": "Eylemler",
  "invitations.status.pending": "Küpe",
  "invitations.status.accepted": "Kabul edildi",
  "invitations.status.cancelled": "İptal edildi",
  "invitations.status.expired": "Günü geçmiş",
  "invitations.actions.cancel": "İptal etmek",
  "invitations.actions.copy": "Bağlantıyı kopyala",
  "invitations.actions.resend": "E-postayı ilet",
  "invitations.waitBeforeResend": "Daveti henüz yeniden gönderemezsiniz. Konuk kullanıcıya spam gönderilmesini önlemek için her gönderim arasında 10 dakika beklemelisiniz.",
  "invitations.captchaQuestion": "%1 + %2 kaç eder?",
  "invitations.resendSuccess": "Davet başarıyla iletildi.",
  "invitations.dailyLimit": "Bugün izin verilen maksimum yeniden gönderim sayısına ulaştınız.",
  "invitations.invalidEmail": "Posta sunucusu bu adresin geçersiz olduğunu bildirdi.",
  "profile.privacy.title": "Mahremiyet",
  "profile.privacy.public_visibility": "Profilimi herkese açık hale getir",
  "profile.privacy.public_warning": "Bu, herhangi bir ArChat® kullanıcısının sizi bulmasına ve bir konuşma başlatmasına olanak tanır.",
  "profile.privacy.private_info": "Profiliniz gizli. Yalnızca davet ettiğiniz veya sizi davet eden kullanıcılar sizinle sohbet edebilecektir.",
  "profile.privacy.private_default": "Daha fazla güvenlik için profiliniz varsayılan olarak gizlidir.",
  "common.save": "Kale",
  "common.saving": "Kaydediliyor...",
  'buttons.accept': 'Kabul et',
  "buttons.cancel": "İptal etmek",
  "buttons.save": "Kale",
  "buttons.edit": "Düzenlemek",
  "buttons.retry": "Yeniden dene",
  "buttons.confirm": "Onaylamak",
  "buttons.yes": "Evet",
  "buttons.no": "HAYIR",
  "buttons.send": "Göndermek",
  "buttons.close": "Kapalı",
  "buttons.continue": "Devam etmek",
  "buttons.delete": "Elemek",
  "buttons.logout": "Dışarı çıkmak",
  "buttons.back": "Geri dönmek",
  "buttons.update": "Güncelleme",
  "buttons.upload": "Arttırmak",
  "buttons.select": "Seçme",
  "achievement.unlocked": "Başarının kilidi açıldı",
  "achievement.continue": "Devam etmek",
  "contact.edit.info.personalized": "Bu değişiklikler yalnızca size özeldir ve diğer kullanıcıları etkilemez.",
  "contact.edit.profileInfo": "Profil Bilgileri",
  "dashboard.loading": "Veriler yükleniyor...",
  "dashboard.error.title": "Hata",
  "dashboard.error.load": "Kullanım verileri yüklenemedi",
  "dashboard.error.generic": "Kontrol paneli yüklenirken hata oluştu",
  "dashboard.error.no_data": "Veri yüklenemedi",
  "dashboard.retry": "Yeniden dene",
  "dashboard.unlimited": "Sınırsız",
  'dashboard.not_available': 'Mevcut değil',
  "dashboard.plan.free": "FREE",
  "dashboard.plan.pro": "PRO",
  "dashboard.plan.enterprise": "ENTERPRISE",
  "dashboard.card.chars": "Karakterler",
  "dashboard.card.chars_month": "Bu ayın karakterleri",
  "dashboard.card.storage": "Depolamak",
  "dashboard.card.devices": "Aktif cihazlar",
  "dashboard.admin.title": "Büyüme metrikleri",
  "dashboard.admin.newUsersToday": "Bugün yeni kullanıcılar",
  "dashboard.admin.messagesSentToday": "Bugün gönderilen mesajlar",
  "dashboard.admin.translationsUsed": "Kullanılan çeviriler",
  "dashboard.admin.invitesCreated": "Davetiyeler oluşturuldu",
  "dashboard.admin.invitesValidated": "Doğrulanmış davetiyeler",
  "dashboard.admin.inviteConversion": "Davetiye dönüşümü",
  "dashboard.admin.kFactor": "K-Faktörü",
  "dashboard.admin.newUsers": "Yeni kullanıcılar",
  "dashboard.admin.messagesSent": "Gönderilen mesajlar",
  "dashboard.admin.noData": "Veri yok",
  "dashboard.admin.kFactor.viral": "viral",
  "dashboard.admin.kFactor.stable": "Stabil",
  "dashboard.admin.kFactor.low": "Düşük",
  "dashboard.admin.emailMetrics": "E-posta metrikleri",
  "dashboard.admin.email.sent": "Gönderilmiş",
  "dashboard.admin.email.delivered": "Teslim edilmiş",
  "dashboard.admin.email.opened": "açık",
  "dashboard.admin.email.clicked": "Tıklamalar",
  "dashboard.admin.email.bounced": "geri döndü",
  "dashboard.admin.email.deliveryRate": "Teslimat oranı",
  "dashboard.admin.email.openRate": "Açık oran",
  "dashboard.admin.email.bounceRate": "hemen çıkma oranı",
  "dashboard.admin.funnelMetrics": "Huni metrikleri",
  "dashboard.admin.funnel.registered": "Kayıtlı",
  "dashboard.admin.funnel.confirmed": "Onaylandı",
  "dashboard.admin.funnel.loggedIn": "İlk giriş",
  "dashboard.admin.funnel.firstMessage": "İlk mesaj",
  "dashboard.admin.funnel.abandoned": "Terk edilmiş",
  "dashboard.admin.funnel.conversionRate": "Dönüşüm oranı",
  "dashboard.admin.funnel.activationRate": "Etkinleştirme oranı",
  "dashboard.admin.funnel.dropoffRate": "Bırakma oranı",
  "dashboard.admin.loading": "Metrikler yükleniyor...",
  "dashboard.admin.errorLoad": "Metrik kontrol paneli yüklenemedi.",
  "dashboard.admin.growthViral": "Viral büyüme",
  "dashboard.admin.growthStable": "İstikrarlı büyüme",
  "dashboard.admin.growthLow": "Düşük büyüme",
  "dashboard.upgrade.title": "Daha fazla kaynağa mı ihtiyacınız var?",
  'dashboard.upgrade.message': 'Upgrade your plan to get more contacts, characters, storage and active devices.',
  "dashboard.upgrade.button": "Planı İyileştir",
  "upgrade.title": "Planı İyileştir",
  "upgrade.close": "Kapalı",
  "upgrade.cancel": "İptal etmek",
  "upgrade.activate": "PRO Planını Etkinleştir",
  "upgrade.activating": "Etkinleştiriliyor...",
  'upgrade.price.amount': '',
  'upgrade.price.period': '',
  'upgrade.price.note': '',
  "upgrade.comparison.title": "Plan Karşılaştırması",
  "upgrade.free.label": "Ücretsiz Plan",
  "upgrade.free.limits.contacts": "Maksimum 2 kişi",
  "upgrade.free.limits.conversations": "Maksimum 2 konuşma",
  "upgrade.free.limits.no_export": "Veri aktarımı yok",
  "upgrade.free.limits.no_advanced": "Gelişmiş özellik yok",
  "upgrade.pro.label": "Profesyonel Plan",
  "upgrade.pro.recommended": "TAVSİYE EDİLEN",
  'upgrade.pro.benefits.contacts': 'Unlimited contacts',
  'upgrade.pro.benefits.contacts.desc': 'Add all the contacts you need without restrictions',
  'upgrade.pro.benefits.conversations': 'Unlimited conversations',
  'upgrade.pro.benefits.conversations.desc': 'Keep all active conversations you need',
  "upgrade.pro.benefits.export": "Konuşmayı dışa aktarma",
  "upgrade.pro.benefits.export.desc": "Görüşmelerinizi birden fazla formatta (PDF, TXT, JSON) dışa aktarın",
  "upgrade.pro.benefits.notifications": "Gelişmiş bildirimler",
  "upgrade.pro.benefits.notifications.desc": "Özel bildirimler ve gelişmiş ayarlar",
  'upgrade.pro.benefits.translation': 'Unlimited automatic translation',
  'upgrade.pro.benefits.translation.desc': 'Translate messages without usage limits',
  'upgrade.pro.benefits.files': 'Unlimited file sharing',
  'upgrade.pro.benefits.files.desc': 'Share files of any size without restrictions',
  "upgrade.pro.benefits.themes": "Özel temalar",
  "upgrade.pro.benefits.themes.desc": "Tüm temalara ve gelişmiş özelleştirmeye erişim",
  "upgrade.pro.benefits.security": "Gelişmiş güvenlik",
  "upgrade.pro.benefits.security.desc": "Ek koruma ve gelişmiş gizlilik özellikleri",
  "upgrade.pro.benefits.analytics": "İstatistik ve analiz",
  "upgrade.pro.benefits.analytics.desc": "Etkinliğinizin ayrıntılı istatistiklerine erişin",
  "upgrade.pro.benefits.priority": "Öncelikli destek",
  "upgrade.pro.benefits.priority.desc": "Sorularınıza öncelikli ilgi ve hızlı yanıt",
  "upgrade.enterprise.label": "Kurumsal Plan",
  "upgrade.enterprise.title": "ENTERPRISE",
  "upgrade.enterprise.benefits.contacts": "Sınırsız kişi",
  "upgrade.enterprise.benefits.support": "7/24 öncelikli destek",
  "upgrade.enterprise.benefits.custom": "Özel çözümler",
  "upgrade.enterprise.benefits.advanced": "Gelişmiş iş özellikleri",
  "upgrade.enterprise.benefits.integration": "Özel entegrasyonlar",
  "upgrade.enterprise.benefits.dedicated": "Özel destek",
  "upgrade.success.title": "PRO Planı Etkinleştirildi",
  "upgrade.success.message": "Planınız PRO'ya yükseltildi. Tüm sınırsız özelliklerin keyfini çıkarın.",
  "upgrade.error.title": "PRO etkinleştirilirken hata oluştu",
  "upgrade.error.message": "Plan güncellenemedi. Lütfen tekrar deneyin.",
  "upgrade.error.generic": "Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.",
  'upgrade.benefits.contacts': 'Unlimited contacts',
  'upgrade.benefits.contacts.desc': 'Add all the contacts you need without restrictions',
  'upgrade.benefits.conversations': 'Unlimited conversations',
  'upgrade.benefits.conversations.desc': 'Keep all active conversations you need',
  "upgrade.benefits.export": "Konuşmayı dışa aktarma",
  "upgrade.benefits.export.desc": "Görüşmelerinizi birden fazla formatta (PDF, TXT, JSON) dışa aktarın",
  "upgrade.benefits.notifications": "Gelişmiş bildirimler",
  "upgrade.benefits.notifications.desc": "Özel bildirimler ve gelişmiş ayarlar",
  'upgrade.benefits.translation': 'Unlimited automatic translation',
  'upgrade.benefits.translation.desc': 'Translate messages without usage limits',
  'upgrade.benefits.files': 'Unlimited file sharing',
  'upgrade.benefits.files.desc': 'Share files of any size without restrictions',
  "upgrade.benefits.themes": "Özel temalar",
  "upgrade.benefits.themes.desc": "Tüm temalara ve gelişmiş özelleştirmeye erişim",
  "upgrade.benefits.security": "Gelişmiş güvenlik",
  "upgrade.benefits.security.desc": "Ek koruma ve gelişmiş gizlilik özellikleri",
  "upgrade.benefits.analytics": "İstatistik ve analiz",
  "upgrade.benefits.analytics.desc": "Etkinliğinizin ayrıntılı istatistiklerine erişin",
  "upgrade.benefits.priority": "Öncelikli destek",
  "upgrade.benefits.priority.desc": "Sorularınıza öncelikli ilgi ve hızlı yanıt",
  "upgrade.limits.contacts": "Maksimum 2 kişi",
  "upgrade.limits.conversations": "Maksimum 2 konuşma",
  "upgrade.limits.no_export": "Veri aktarımı yok",
  "upgrade.limits.no_advanced": "Gelişmiş özellik yok",
  "api.error.image_processing_not_available": "Görüntü işleme sunucuda kullanılamıyor",
  "api.error.image_functions_not_available": "Görüntü işleme işlevleri mevcut değil",
  "api.error.method_not_allowed": "İzin verilmeyen yöntem",
  "api.error.user_not_identified": "Tanımlanamayan kullanıcı",
  "api.error.upload_file_too_large_php": "Dosya PHP'nin izin verdiği maksimum boyutu aşıyor",
  "api.error.upload_file_too_large_form": "Dosya, formun izin verdiği maksimum boyutu aşıyor",
  "api.error.upload_file_partial": "Dosya kısmen yüklendi",
  "api.error.upload_no_file": "Hiçbir dosya yüklenmedi",
  "api.error.upload_no_temp_dir": "Geçici dizin eksik",
  "api.error.upload_cant_write": "Dosyayı diske yazarken hata oluştu",
  "api.error.upload_extension_stopped": "Bir PHP uzantısının yüklenmesi durduruldu",
  "api.error.upload_generic": "Dosya yükleme hatası",
  "api.error.file_type_not_allowed": "Dosya türüne izin verilmiyor. Yalnızca resimlere (JPEG, PNG, GIF, WEBP) izin verilir",
  "api.error.file_too_large": "Dosya çok büyük (en fazla 10MB)",
  "api.error.storage_limit_exceeded": "Depolama sınırı aşıldı. Daha fazla dosya yüklemek için planınızı yükseltin.",
  "api.error.user_not_found": "Kullanıcı bulunamadı veya etkin değil",
  "api.error.image_directory_access": "Resimler dizinine erişilirken hata oluştu",
  "api.error.file_extension_not_allowed": "Dosya uzantısına izin verilmiyor",
  "api.error.temp_file_save": "Geçici dosya kaydedilirken hata oluştu",
  "api.error.image_processing": "Resim işlenirken hata oluştu",
  "api.error.database_update": "Veritabanı güncellenirken hata oluştu",
  "api.error.internal_server_error": "İç Sunucu Hatası",
  "api.error.internal_server_error_debug": "İç Sunucu Hatası",
  "api.error.user_id_required": "Gerekli kullanıcı kimliği",
  "api.error.profile_not_found": "Profil bulunamadı",
  "api.error.profile_load_failed": "Profil yüklenirken hata oluştu",
  "api.error.invalid_data": "Geçersiz veri",
  "api.error.validation_errors": "Doğrulama hataları",
  "api.error.profile_update_failed": "Profil güncellenemedi",
  "api.error.profile_update_error": "Profil güncellenirken hata oluştu",
  "api.success.photo_updated": "Fotoğraf güncellendi",
  "api.success.profile_loaded": "Profil başarıyla yüklendi",
  "api.success.profile_updated": "Profil başarıyla güncellendi",
  "errors.deviceLimit.title": "Cihaz sınırına ulaşıldı",
  "errors.deviceLimit.solution": "Devam etmek için diğer cihazlardaki oturumunuzu kapatın veya planınızı yükseltin.",
  "errors.network.title": "Bağlantı hatası",
  "errors.network.message": "Sunucuya bağlanılamadı. İnternet bağlantınızı kontrol edin.",
  "errors.server.invalidResponse.title": "Sunucu hatası",
  "errors.server.invalidResponse.message": "Sunucu geçersiz bir yanıt döndürdü. Tekrar deneyin.",
  "errors.modal.title": "Hata",
  "errors.modal.copyDetails": "Ayrıntıyı kopyala",
  "errors.modal.close": "Kapalı",
  "errors.modal.reportSupport": "Desteğe rapor verin",
  "errors.modal.code": "Kod",
  "errors.modal.message": "Mesaj",
  "errors.modal.path": "Rota",
  "errors.modal.time": "Saat",
  "errors.modal.timestamp": "Zaman damgası",
  "errors.modal.copied": "Kopyalanan ayrıntı",
  "errors.generic.title": "Hata",
  "errors.generic.message": "Bir hata oluştu. Tekrar deneyin.",
  "errors.unexpected": "Beklenmeyen bir hata oluştu. Tekrar deneyin.",
  "errors.boundary.title": "TEPKİ HATASI YAKALANDI",
  "errors.boundary.request_id": "X-İstek Kimliği:",
  "errors.boundary.correlate": "Backend/logs/structured.log ile eşleyin",
  "errors.boundary.message_label": "Mesaj:",
  "errors.boundary.stack_trace": "Yığın izleme",
  "errors.boundary.component_stack": "bileşen yığını",
  "errors.boundary.empty": "(boş)",
  "errors.boundary.reload_page": "Sayfayı yeniden yükle",
  "errors.ui_boundary.refresh": "ArChat arayüz hatası — sayfa yeniden yükleniyor",
  "bootstrap.error.title": "ArChat® — Önyükleme Hatası",
  "common.reload": "Yeniden şarj et",
  "errors.avatarTooLarge": "Resim izin verilen 2MB boyutunu aşıyor.",
  "errors.avatarTooLarge.title": "Resim çok büyük",
  "errors.avatarTooLarge.message": "Resim izin verilen 2MB boyutunu aşıyor.",
  "errors.invalidImageType": "Seçilen dosya geçerli bir resim değil.",
  "errors.invalidImageType.title": "Geçersiz dosya",
  "errors.invalidImageType.message": "Seçilen dosya geçerli bir resim değil.",
  "errors.uploadFailed": "Resim yüklenemedi. Tekrar deneyin.",
  "errors.uploadFailed.title": "Yükleme hatası",
  "errors.uploadFailed.message": "Resim yüklenemedi. Tekrar deneyin.",
  "errors.conversationCreate": "Konuşma oluşturulurken hata oluştu. Lütfen tekrar deneyin.",
  "errors.conversationInvalidId": "Geçersiz görüşme kimliği.",
  "errors.conversationOpen": "Görüşme açılırken hata oluştu. Lütfen tekrar deneyin.",
  "errors.favoriteUpdate": "Favori güncellenemedi",
  "errors.blockUpdate": "Kilit güncellenemedi",
  "errors.messageEdit": "Mesaj düzenlenirken hata oluştu.",
  "errors.generic.403.title": "Erişim hatası",
  "errors.generic.403.message": "Bu eylemi gerçekleştirme izniniz yok.",
  "errors.saas_max_users": "Planın kullanıcı sınırına ({current}/{limit}) ulaşıldı.",
  "errors.tenant_frozen": "Kiracı geçici olarak engellendi.",
  "errors.auth_invalid_credentials": "Yanlış kullanıcı adı veya şifre.",
  "errors.foundation_sold_out": "Kurucu kontenjanları tükendi.",
  "errors.unexpected_error": "Beklenmeyen bir hata oluştu. Tekrar deneyin.",
  "errors.accountInactive.title": "Hesap etkin değil. Yeniden etkinleştirmek için e-postanızı tamamlayın.",
  "errors.userInactive.title": "Devre dışı bırakılmış hesap",
  "errors.tenantMismatch.title": "Kiracı hatası",
  "errors.accountInactive.activate": "Şimdi etkinleştir",
  "errors.accountInactive.accept": "Kabul etmek",
  "errors.accountInactive.success": "Hesap yeniden etkinleştirildi. Artık giriş yapabilirsiniz.",
  "errors.accountInactive.fail": "Hesap yeniden etkinleştirilemedi. Tekrar deneyin.",
  "errors.accountInactive.completeSuccess": "Hesap e-postanızla etkinleştirildi. Artık giriş yapabilirsiniz.",
  "errors.accountInactive.completeFail": "Etkinleştirme tamamlanamadı. E-postayı kontrol edin ve tekrar deneyin.",
  "plan.errors.deviceLimit.title": "Plan sınırına ulaşıldı",
  "plan.errors.deviceLimit.message": "Mevcut planınızda aynı anda bağlanan cihazların sayısı sınırlıdır.",
  "plan.errors.deviceLimit.solution": "Devam etmek için diğer cihazlardan çıkış yapın veya planınızı PRO'ya yükseltin.",
  "plan.errors.contactsLimit.title": "İletişim sınırına ulaşıldı",
  "plan.errors.contactsLimit.message": "Mevcut planınızın sahip olabileceğiniz kişi sayısı konusunda bir sınırı var.",
  "plan.errors.contactsLimit.solution": "Daha fazla kişi eklemek için planınızı PRO'ya yükseltin.",
  "plan.errors.invitationsLimit.title": "Davet sınırına ulaşıldı",
  "plan.errors.invitationsLimit.message": "Mevcut planınızda günlük gönderebileceğiniz davetiye sayısında bir sınırlama var.",
  "plan.errors.invitationsLimit.solution": "Daha fazla davetiye göndermek için planınızı PRO'ya yükseltin.",
  "plan.errors.messagesLimit.title": "Mesaj sınırına ulaşıldı",
  "plan.errors.messagesLimit.message": "Mevcut planınızın günlük gönderebileceğiniz mesaj sayısında bir sınırı vardır.",
  "plan.errors.messagesLimit.solution": "Daha fazla mesaj göndermek için planınızı PRO'ya yükseltin.",
  "plan.errors.storageLimit.title": "Depolama sınırına ulaşıldı",
  "plan.errors.storageLimit.message": "Mevcut planınızın kullanılabilir depolama alanı miktarında bir sınırı var.",
  "plan.errors.storageLimit.solution": "Daha fazla depolama alanı için PRO'ya yükseltin.",
  "plan.errors.chatsLimit.title": "Konuşma sınırına ulaşıldı",
  "plan.errors.chatsLimit.message": "Mevcut planınızın yapabileceğiniz görüşme sayısı konusunda bir sınırı var.",
  "plan.errors.chatsLimit.solution": "Daha fazla görüşme oluşturmak için planınızı PRO'ya yükseltin.",
  "plan.errors.upgradeRequired.title": "Plan yükseltmesi gerekli",
  "plan.errors.upgradeRequired.message": "Bu özellik şu anda sahip olduğunuzdan daha yüksek bir plan gerektirir.",
  "plan.errors.upgradeRequired.solution": "Bu özelliğe erişmek için planınızı PRO'ya yükseltin.",
  "appearance.theme.system": "Sistem",
  "appearance.theme.corporate": "Kurumsal",
  "theme.system": "Sistem",
  "theme.corporate": "Kurumsal",
  "founder.modalClose": "Kapalı",
  "founder.activeCountLabel": "Aktif Kurucular",
  "founder.urgency.lastSlots": "Son Kurucu kontenjanları mevcut",
  "founder.positionLabel": "Kurucu #{position} / {limit}",
  "founder.leaderboard.title": "En İyi Kurucular",
  'auth.tagline': 'Dilin ne olursa olsun anlaşılma gücü',
  'auth.sign_in': 'Giriş yap',
  'auth.create_account': 'Hesap oluştur',
  'ui.search_contact': 'Kişi ara...',
  'ui.language': 'Dil',
  "profile.users": "Kullanıcılar",
  "profile.settings": "Yapılandırma",
  "profile.appearance": "Dış görünüş",
  "contacts.mode": "Mod",
  "contacts.sent": "Gönderilmiş",
  "contacts.actions": "Eylemler",
  "contacts.pending": "Küpe",
  "contacts.available": "Mevcut",
  "contacts.invited_registered": "Misafir - Kayıtlı",
  "table.email": "E-posta",
  "table.language": "Dil",
  "table.mode": "Mod",
  "table.status": "Durum",
  "table.sent": "Gönderilmiş",
  "table.actions": "Eylemler",
  "admin.access_denied.message": "Mesaj",
  "admin.access_denied.title": "Başlık",
  "admin.action.change_plan": "Planı değiştir",
  "admin.action.reactivate": "Yeniden etkinleştir",
  "admin.action.suspend": "Askıya almak",
  "admin.action.view": "Görüş",
  "admin.confirm.change_plan.message": "Mesaj",
  "admin.confirm.change_plan.title": "Başlık",
  "admin.confirm.suspend.message": "Mesaj",
  "admin.confirm.suspend.title": "Başlık",
  "admin.details.created": "Oluşturuldu",
  "admin.details.current_plan": "Mevcut plan",
  "admin.details.domain": "İhtisas",
  "admin.details.last_activity": "Son etkinlik",
  "admin.details.name": "yam",
  "admin.details.plan": "Planı",
  "admin.details.status": "Durum",
  "admin.details.subscription": "Abonelik",
  "admin.details.tenant_id": "Kiracı Kimliği",
  "admin.details.tenant_info": "Kiracı bilgisi",
  "admin.details.usage": "Kullanım",
  "admin.error.change_plan": "Planı değiştir",
  "admin.error.generic": "Genel",
  "admin.error.load_details": "Ayrıntıları yükle",
  "admin.error.load_tenants": "Kiracıları yükle",
  "admin.error.reactivate": "Yeniden etkinleştir",
  "admin.error.suspend": "Askıya almak",
  "admin.error.title": "Başlık",
  "admin.filter.active": "Etkinleştir",
  "admin.filter.all_plans": "Tüm planlar",
  "admin.filter.all_status": "Tüm durum",
  "admin.filter.suspended": "Askıya almak",
  "admin.limit.devices": "Cihazlar",
  "admin.limit.invitations": "Davetiyeler",
  "admin.limit.messages": "mesajlar",
  "admin.limit.storage": "Depolamak",
  "admin.limit.users": "Kullanıcılar",
  "admin.loading": "Yükleniyor",
  "admin.no_tenants": "Kiracı olmayanlar",
  "admin.plan.enterprise": "Enterprise",
  "admin.plan.free": "Free",
  "admin.plan.pro": "Pro",
  "admin.status.active": "Etkinleştir",
  "admin.status.suspended": "Askıya almak",
  'admin.subscription.id': 'Id',
  "admin.subscription.last_payment": "Son ödeme",
  "admin.subscription.status": "Durum",
  "admin.subtitle": "Altyazı",
  "admin.success.plan_changed": "Plan değiştirildi",
  "admin.success.tenant_reactivated": "Kiracı yeniden etkinleştirildi",
  "admin.success.tenant_suspended": "Kiracı askıya alındı",
  "admin.success.title": "Başlık",
  "admin.table.actions": "Eylemler",
  "admin.table.messages": "mesajlar",
  "admin.table.name": "yam",
  "admin.table.plan": "Planı",
  "admin.table.status": "Durum",
  "admin.table.storage": "Depolamak",
  "admin.table.tenant_id": "Kiracı Kimliği",
  "admin.table.users": "Kullanıcılar",
  "admin.title": "Başlık",
  "admin.usage.devices": "Cihazlar",
  "admin.usage.invitations": "Davetiyeler",
  "admin.usage.messages": "mesajlar",
  "admin.usage.storage": "Depolamak",
  "admin.usage.users": "Kullanıcılar",
  "auth.login": "Giriş yapmak",
  "auth.register": "Kayıt olmak",
  "auth.reset_password": "şifreyi sıfırla",
  "billing.cancel.button": "düğme",
  "billing.cancel.canceling": "İptal",
  "billing.cancel.confirm": "Onaylamak",
  "billing.cancel.error": "Hata",
  "billing.cancel.success": "başarı",
  "billing.character_billing.characters_used": "Kullanılan karakterler",
  "billing.character_billing.consumption_pct": "Tüketim yüzdesi",
  "billing.character_billing.days_remaining": "Kalan gün sayısı",
  "billing.character_billing.deletion_date": "Silme tarihi",
  "billing.character_billing.period_start": "Dönem başlangıcı",
  "billing.character_billing.renewal_date": "Yenileme tarihi",
  "billing.character_billing.title": "Başlık",
  "billing.current_plan": "Mevcut plan",
  "billing.founder_badge": "Kurucu rozeti",
  "billing.no_plans": "Planlama",
  'billing.subscription.canceled': 'Canceled',
  'billing.subscription.canceled_note': 'Canceled note',
  "billing.subscription.next_payment": "Sonraki ödeme",
  "billing.subscription.plan": "Planı",
  'billing.subscription.price': 'Plan fiyatı',
  "billing.subscription.started": "Başlatıldı",
  "billing.subscription.status": "Durum",
  "billing.subscription.mp_flow.subscribe_failed": "Abonelik başlatılamadı. Tekrar deneyin.",
  "billing.subscription.mp_flow.change_plan_failed": "Plan değiştirilemezdi. Tekrar deneyin.",
  "billing.subscription.mp_status.pending": "Küpe",
  "billing.subscription.mp_status.authorized": "Yetkili",
  "billing.subscription.mp_status.active": "Aktif",
  "billing.subscription.mp_status.paused": "Duraklatıldı",
  "billing.subscription.mp_status.cancelled": "İptal edildi",
  "billing.subscription.mp_status.inactive": "Etkin değil",
  "billing.subscription.mp_status.unknown": "Bir yabancı",
  "billing.unlimited": "Sınırsız",
  "billing.update_plan": "Planı güncelle",
  "billing.update_plan_modal.title": "Başlık",
  "billing.usage.loading": "Yükleniyor",
  "common.accept": "Kabul etmek",
  "common.confirmPassword": "Şifreyi Onayla",
  'common.continue': 'Devam',
  "common.error": "Hata",
  "dashboard.upgrade.to_plan": "Planlamak",
  "emoji.noResults": "Sonuç Yok",
  "emoji.pick": "Seçmek",
  "export.restricted.message": "Mesaj",
  "export.restricted.title": "Başlık",
  "export.restricted.upgrade": "Güncelleme",
  "founder.*": "*",
  "help.faq.a1": "A1",
  "help.faq.a2": "A2",
  "help.faq.a3": "A3",
  "help.faq.a4": "A4",
  "help.faq.a5": "A5",
  "help.faq.a6": "A6",
  "help.faq.a7": "A7",
  "help.faq.q1": "1. Çeyrek",
  "help.faq.q2": "2. Çeyrek",
  "help.faq.q3": "3. Çeyrek",
  "help.faq.q4": "4. Çeyrek",
  "help.faq.q5": "S5",
  "help.faq.q6": "S6",
  "help.faq.q7": "S7",
  "help.faq.title": "Başlık",
  "help.howWorks.step4.point7": "Nokta7",
  "help.message_time_context.free_vs_pro": "Ücretsiz ve profesyonel",
  "help.message_time_context.point5": "Nokta5",
  "help.plans.enterprise.benefits": "Faydalar",
  "help.plans.enterprise.description": "Tanım",
  "help.plans.enterprise.title": "Başlık",
  "help.plans.foundation.devices": "Cihazlar",
  "help.plans.free.description": "Tanım",
  "help.plans.free.devices": "Cihazlar",
  "help.plans.free.limits": "Sınırlar",
  "help.plans.free.title": "Başlık",
  "help.plans.intro": "Giriş",
  "help.plans.pro.benefits": "Faydalar",
  "help.plans.pro.description": "Tanım",
  "help.plans.pro.devices": "Cihazlar",
  'help.plans.pro.price': '$19 / ay',
  "help.plans.pro.title": "Başlık",
  "help.plans.pro.upgrade": "Güncelleme",
  "help.plans.title": "Başlık",
  "help.plans.urgent_slots_badge": "Acil slot rozeti",
  "help.slogan.final": "Son",
  "help.suggestions.point1": "Nokta1",
  "help.suggestions.point2": "Nokta2",
  "help.suggestions.title": "Başlık",
  "invitation.already_contact_added": "Kişi zaten eklendi",
  "invitation.already_contact_title": "Zaten iletişim başlığı",
  "invitation.already_pending": "Zaten beklemede",
  "invitation.language.invalid": "Geçersiz",
  "message.send": "Göndermek",
  "message.sendFile": "Dosya Gönder",
  "messages.conversations": "Konuşmalar",
  "messages.no_conversations_subtitle": "Konuşma altyazısı yok",
  "messages.no_conversations_title": "Konuşma başlığı yok",
  "presence.custom.edit": "Düzenlemek",
  "profile.enrichment.country": "ülke",
  "profile.enrichment.country.select": "Seçme",
  "profile.enrichment.description": "Tanım",
  "profile.enrichment.org_size": "Kuruluş boyutu",
  "profile.enrichment.org_size.placeholder": "yer tutucu",
  "profile.enrichment.save": "Kaydetmek",
  "profile.enrichment.skip": "atlamak",
  "profile.enrichment.title": "Başlık",
  "profile.enrichment.usage_type.label": "Etiket",
  "profile.enrichment.usage_type.placeholder": "yer tutucu",
  "profile.founderPosition": "Kurucu Pozisyonu",
  "settings.confirmations.description": "Tanım",
  "settings.confirmations.disable": "Devre dışı bırakmak",
  "settings.confirmations.title": "Başlık",
  "settings.confirmations.updated": "Güncellendi",
  "settings.title": "Başlık",
  "theme.description": "Tanım",
  "google.unavailable_tenant": "Bu kiracı için Google kullanılamıyor.",
  "google.unavailable": "Google kullanılamıyor.",
  "google.verify_client_id": "İstemci Kimliğini Google Cloud Console'da doğrulayın.",
  'google.login_aria': 'Google ile giriş yap',
  "message.preview_alt": "Önizleme",
  "message.image_attachment_alt": "Ekli resim",
  "profile.avatar.alt": "avatar",
  "plan.name.free": "FREE",
  "plan.name.pro": "PRO",
  "plan.name.foundation": "FOUNDATION",
  "plan.name.enterprise": "ENTERPRISE",
  "register.emailPlaceholder": "you@email.com",
  "invitation.top.loading": "En iyi davetliler yükleniyor...",
  "invitation.top.empty": "Henüz öne çıkan davetli yok.",
  "invitation.contacts.title": "Kişileri davet et",
  "invitation.contacts.safe_phase_note": "Güvenli aşama aktif: gerçek limitler üzerinde etkisi olmayan bekleyen faydalar.",
  "invitation.contacts.generate_code": "Kod/bağlantı oluştur",
  "invitation.contacts.refresh_top3": "İlk 3'ü yenile",
  "invitation.contacts.hide_full_ranking": "Tam sıralamayı gizle",
  "invitation.contacts.show_full_ranking": "Tam sıralamayı göster",
  "invitation.contacts.hide_metrics_dashboard": "Metrik kontrol panelini gizle",
  "invitation.contacts.show_metrics_dashboard": "Metrik kontrol panelini göster",
  "invitation.contacts.prepared_link_label": "Hazırlanan bağlantı:",
  "invitation.contacts.email_placeholder": "e-posta@alanadi.com",
  "invitation.contacts.register_pending": "Bekleyen daveti kaydedin",
  "invitation.contacts.status_summary": "Durum özeti",
  "invitation.contacts.sent_invitations": "Davetiyeler gönderildi",
  "invitation.contacts.invited_email": "Davet edilen e-posta",
  "invitation.contacts.code": "kod",
  "invitation.contacts.no_sent_invitations": "Henüz davetiye göndermedim.",
  "invitation.contacts.simulated_rewards": "Elde edilen simüle edilmiş ödüller",
  "invitation.contacts.no_simulated_rewards": "Henüz simüle edilmiş ödül yok.",
  "common.id": "İD",
  "common.created": "Oluşturuldu",
  "plan.pro_contacts": "Hasta 100 contactos por usuario",
  "common.status": "Durum",
  'login.prompt_create_account_with_name': 'Bu isimle bir hesap oluşturmak ister misiniz?',
  'auth.pending_activation.title': 'Hesap etkinleştirmeyi bekliyor',
  'auth.pending_activation.body': 'Hesabınız henüz etkinleştirilmedi. ArChat\'e giriş yapmak için gelen kutunuzu kontrol edin ve kaydınızı onaylayın.',
  'auth.pending_activation.back_to_login': 'Girişe dön',
  'auth.pending_activation.support_prefix': 'Yardıma mı ihtiyacınız var? Destekle iletişime geçin:',
  "auth.pending_activation.support_email": "info@archat.com.ar",
  'auth.pending_activation.email_label': 'Etkinleştirmeyi yeniden göndermek için e-posta',
  'auth.pending_activation.email_placeholder': 'siz@email.com',
  'auth.pending_activation.email_required': 'Etkinleştirmeyi yeniden göndermek için kayıt olurken kullandığınız e-postayı girin.',
  'auth.pending_activation.sent_title': 'Etkinleştirme e-postası gönderildi',
  'auth.pending_activation.sent_body': 'Adres bekleyen bir hesapla eşleşiyorsa yeni bir etkinleştirme bağlantısı gönderdik. Gelen kutunuzu ve spam klasörünü kontrol edin.',
  'auth.pending_activation.soft_error_title': 'Yeniden gönderme kullanılamıyor',
  'auth.pending_activation.soft_error_body': 'Yeniden gönderimi şu anda işleyemedik. Birkaç dakika sonra tekrar deneyin veya info@archat.com.ar adresinden bize ulaşın.',
  'auth.pending_activation.resend_again': 'Tekrar gönder',
  'plans.upgrade.title': 'Plani yuksel',
  'plans.upgrade.comparison': 'Plan karşılaştırması',
  'plans.upgrade.billing': '',
  'plans.upgrade.cancel_anytime': 'Istegin zaman iptal et',
  'plans.actions.upgrade_pro': 'PRO planına geç',
  'plans.actions.become_founder': 'Founder ol',

  'plans.modal.card.current_badge': 'Mevcut planınız',

  'plans.modal.card.lower_tier': 'Aktif planınızın altında',

  'plans.modal.card.manage_in_profile': 'Değiştirmek veya iptal için: Profilde Abonelik ve faturalandırma.',
                'plans.modal.card.cancel_subscription': 'Aboneliği iptal et',
                'plans.modal.cancel_confirm.title': 'Aboneliği iptal et veya yönet',
                'plans.modal.cancel_confirm.body': 'Ödeme, faturalar veya iptal için güvenli Paddle portalı yeni sekmede açılacak.',
                'plans.modal.cancel_confirm.continue_button': 'Devam',
                'plans.modal.cancel_confirm.back_button': 'Geri',
                'plans.modal.cancel_paddle_fallback.title': 'Aboneliğini yönet',
                'plans.modal.cancel_paddle_fallback.body': 'Paddle faturalama portalı bu ortamda açılmaz (ör. yerel geliştirme veya henüz bağlantı yok). Planları burada incelemeye ve karşılaştırmaya devam edebilirsiniz.',
                'plans.modal.cancel_paddle_fallback.confirm': 'Tamam',
  "plans.upgrade_required": "PRO planında mevcut",
  'settings.heading': 'Ayarlar',
  'settings.dashboard': 'Gösterge',
  'settings.dashboardDescription': 'Ana panel ve görünür kutucuklar için yerel tercihler.',
  'settings.dashboardGridHeading': 'Panel kutucukları',
  'settings.dashboardShowOnStartDescription': 'Açıkken, oturum açtıktan sonra kişi listesi yerine panel açılır.',
  'settings.dashboardBlockWelcome': 'Hoş geldiniz',
  'settings.dashboardBlockUsage': 'Plan kullanımı',
  'settings.dashboardBlockFiles': 'Dosyalarım',
  'settings.dashboardBlockPromotions': 'Promosyonlar',
  'settings.dashboardBlockSessions': 'Oturumlar',
  'settings.dashboardWelcomeDescription': 'İlk adımlar, kişi davet ve yardım kısayolları.',
  'settings.dashboardUsageDescription': 'Limitlere göre kullanım: kişiler, karakter, depolama, cihazlar.',
  'settings.dashboardFilesDescription': 'Dosyalarım bölümünde görünen dosyalar ve alan özeti.',
  'settings.dashboardPromotionsDescription': 'Kampanya özeti ve programa bağlantı.',
  'settings.dashboardSessionsDescription': 'Aktif oturumlar ve cihazlar; varsa diğer oturumları kapatma.',
  'settings.enabled': 'Açık',
  'settings.disabled': 'Kapalı',
  'settings.showDashboardOnStart': 'Girişte panoyu göster',
  'settings.showWelcomeBlock': 'Karşılama bloğu',
  'settings.showPromotionsBlock': 'Kampanya bloğu',
  'settings.showUsageBlock': 'Plan kullanımı',
  'settings.showRecentConversationsBlock': 'Son görüşmeleri göster (kişi başına son ileti)',
  'settings.showSessionsBlock': 'Aktif oturumlar',
  'settings.showFilesBlock': 'Dosya özeti',
  'settings.dashboardLocalNote': 'Profil API gelene kadar tercihler bu tarayıcıda saklanır.',
  'settings.appearanceSettings': 'Görünüm',
  'settings.argentinaTheme': 'Arjantin teması',
  'settings.darkMode': 'Karanlık mod',
  'settings.language': 'Dil',
  'settings.messageSound': 'Mesaj sesi',
  'settings.playSoundDescription': 'Yeni mesajlar veya önemli uyarılar için ses çal.',
  'settings.messageSoundEnabled': 'Açık',
  'settings.messageSoundDisabled': 'Kapalı',
  'settings.accountSettings': 'Hesap',
  'settings.deleteAccount': 'Hesabı sil',
  'settings.deleteAccountWarning': 'Bu işlem kalıcıdır. Verileriniz, mesajlarınız, kişileriniz ve ayarlarınız platformun silme sürecine göre kaldırılır.',
  'settings.deleteMyAccount': 'Hesabımı sil',
  'dashboard.contacts': 'Kişiler',
  'dashboard.characters': 'Karakterler',
  'dashboard.storage': 'Depolama',
  'dashboard.active_devices': 'Aktif cihazlar',
  'dashboard.need_more_resources': 'Daha fazla kaynağa mı ihtiyacınız var?',
  'dashboard.upgrade_message': 'Daha fazla kişi, karakter, depolama ve aktif cihaz için planınızı yükseltin.',
  'dashboard.upgrade_button': 'PRO\'ya yükselt',
  'dashboard.upgrade_button_pro': 'PRO\'ya yükselt',
  'dashboard.upgrade_button_foundation': 'FOUNDATION\'a yükselt',
  'files.preview': 'Önizleme',
  'files.previewFile': 'Dosya önizlemesi',
  'files.previewUnavailable': 'Önizleme kullanılamıyor.',
  'files.previewLoading': 'Önizleme yükleniyor…',
  'files.openPreview': 'Önizleme',
  'files.downloadFile': 'Dosyayı indir',
  'files.downloadFailed': 'Dosya indirilemedi. Bağlantıyı ve oturumu kontrol edip tekrar deneyin.',
  'files.closePreview': 'Önizlemeyi kapat',
  'files.unsupportedPreview': 'Bu dosya türü için önizleme yok. Ayrıntıları görebilir veya indirebilirsiniz.',
  'files.pdfPreviewHelp': 'Tarayıcı PDF’yi gömülü göstermeyebilir. Açmak için indirin.',
  'files.labelFileType': 'Tür',
  'files.previewForbidden': 'Önizleme izniniz yok.',
  'files.previewNotFound': 'Dosya kullanılamıyor veya artık hesabınızda görünmüyor.',
  'files.unavailableForFree': 'Dosyalarım, FREE planda yer almaz.',
  'files.availableInFoundationAndPro': 'Dosyalarım, FOUNDATION ve PRO planlarında kullanılabilir.',
  'files.filesFeatureRestricted': 'Bu özellik mevcut planınızda yok.',
  'files.filesLoadError': 'Dosyalar yüklenirken hata oluştu.',
  'files.uploadUnavailableForFree': 'Dosya göndermek FREE planda yok.',
  'files.uploadAvailableInFoundationAndPro': 'Dosya göndermek FOUNDATION ve PRO’da vardır.',
  'files.recipientStorageFull': 'Alıcının bu dosyayı almak için yeterli alanı yok.',
  'files.recipientNoAvailableStorage': 'Alıcının bu dosyayı almak için yeterli alanı yok.',
  'files.storageQuotaExceeded': 'Plan depolama sınırına ulaştınız.',
  'files.freeStorageLimit': 'FREE planda alınan dosyalar için 5 MB depolama vardır.',
  'settings.unreadEmailReminderSection': 'Okunmamış özet e-postası',
  'settings.unreadEmailReminderDescription': 'Yeni mesajları veya dosyaları aşağıdaki süreden uzun süre okumazsanız ArChat tek bir özet e-postası gönderir (her mesaj için ayrı değil).',
  'settings.unreadEmailReminderToggle': 'Özetleri e-postayla gönder',
  'settings.unreadEmailDelayHours': 'Göndermeden önce bekleme (saat)',
  'settings.unreadEmailDelayHint': '1–168 saat (en fazla bir hafta). E-posta dili profilden alınır.',
  'subjects.title': 'Konular',
  'subjects.singular': 'Konu',
  'subjects.plural': 'Konular',
  'subjects.general': 'Genel',
  'subjects.new': 'Yeni konu',
  'subjects.create': 'Konu oluştur',
  'subjects.rename': 'Yeniden adlandır',
  'subjects.finish': 'Bitir',
  'subjects.reopen': 'Yeniden aç',
  'subjects.select': 'Devam',
  'subjects.status.open': 'Açık',
  'subjects.status.pending': 'Beklemede',
  'subjects.status.finished': 'Tamamlandı',
  'subjects.limitReached': 'Bu görüşmedeki aktif konu sınırına ulaştınız. Yeni oluşturmak için önce bir konuyu bitirin.',
  'subjects.limitReachedFree': 'FREE planda görüşme başına en fazla 3 aktif konu. Yeni oluşturmak için önce bir konuyu bitirin.',
  'subjects.limitReachedPro': 'PRO planda görüşme başına en fazla 5 aktif konu. Yeni oluşturmak için önce bir konuyu bitirin.',
  'subjects.limitReachedFoundation': 'FOUNDATION planda görüşme başına en fazla 5 aktif konu. Yeni oluşturmak için önce bir konuyu bitirin.',
  'subjects.activeLimitsLine': 'Aktif konular: {current} / {max}',
  'subjects.closedListTitle': 'Kapatılmış konular',
  'subjects.viewClosed': 'Kapatılmış konuları görüntüle',
  'subjects.noClosedSubjects': 'Kapatılmış konu yok.',
  'subjects.reopenSubject': 'Yeniden aç',
  'subjects.reopenedSubjects': 'Yeniden açılan konular',
  'subjects.reopenLimitReached':
    'Aktif konu sınırına ulaştınız. Bunu yeniden açmak için başka bir konuyu bitirin.',
  'subjects.ownerOnlyReopen': 'Bu konuyu yalnızca oluşturan kişi yeniden açabilir.',
  'subjects.modal.title': 'Görüşme konuları',
  'subjects.modal.subtitle': 'Bu görüşmenin konularını seçin veya yönetin.',
  'subjects.contactLabel': 'İLETİŞİM:',
  'subjects.ownerOnlyRename': 'Konuyu yalnızca oluşturan kişi yeniden adlandırabilir.',
  'subjects.ownerOnlyStateChange': 'Konunun durumunu yalnızca oluşturan kişi değiştirebilir.',
  'subjects.createdByOther': 'Bu konuyu karşı taraf oluşturdu. Yanıt verebilirsiniz ancak adını değiştiremezsiniz.',
  'subjects.empty': 'Gösterilecek konu yok.',
  'subjects.noResults': 'Konu bulunamadı.',
  'subjects.error.generic': 'İşlem tamamlanamadı. Tekrar deneyin.',
  'subjects.error.featureDisabled': 'Konular bu ortamda kullanılamıyor.',
  'subjects.error.duplicateName': 'Bu ada sahip etkin bir konu zaten var.',
  'subjects.error.ownerRequired': 'Bu konuyu değiştirme izniniz yok.',
  'subjects.error.defaultCannotRename': 'Genel konusu yeniden adlandırılamaz.',
  'subjects.error.defaultCannotFinish': 'Genel konusu bitirilemez.',
  'subjects.current': 'Konu',
  'subjects.change': 'Konuyu değiştir',
  'subjects.currentLabel': 'Konu:',
  'subjects.changeSubject': 'Konuyu değiştir',
  'subjects.closedCannotSend': 'Bu konu tamamlandı. Yeni mesaj göndermek için yeniden açın.',
  'subjects.selectBeforeSend': 'Mesajları görüntülemek ve göndermek için pencerede bir konu seçin.',
  'subjects.loadingMessages': 'Bu konu için mesajlar yükleniyor…',
  'subjects.messageFilterError': 'Bu konu için mesajlar yüklenemedi.',
  ...PRESET_LOCALES.tr,
  "auth.login.clear_password_lock_after_reset": "Şifremi zaten değiştirdim (örn. başka bir cihazda)",
  "auth.signup_disabled": "Bu ortamda yeni hesap kaydı geçici olarak devre dışı bırakıldı.",
  "auth.reset_user_not_found": "Bu e-postayla ilişkili bir hesap bulamadık. Doğru yazıldığını kontrol edin veya yeni bir hesap oluşturun.",
  "account.not_found": "Hesap bulunamadı.",
  "menu.plans": "Planlar",
  "files.title": "dosyalarım",
  "files.filter_all": "Tüm",
  "files.filter_sent": "Gönderilmiş",
  "files.filter_received": "Kabul edilmiş",
  "files.filter_images": "Görseller",
  "files.filter_documents": "Belgeler",
  "files.col_name": "İsim",
  "files.col_size": "Boyut",
  "files.col_date": "Tarih",
  "files.col_direction": "Yön.",
  "files.col_actions": "Eylemler",
  "files.sent": "📤 Gönderildi",
  "files.received": "📥 Alındı",
  "files.download": "Deşarj",
  "files.delete_for_me": "Benim için sil",
  "files.delete_confirm_title": "Dosyayı sil",
  "files.delete_confirm_message": "Bu dosya hesabınızdan silinecek. Diğer kişi için silinmeyecektir. Devam etmek?",
  "files.empty": "Dosyalarınız yok.",
  "files.error_loading": "Dosyalar yüklenirken hata oluştu.",
  "files.load_more": "Daha fazlasını yükle",
  "message.status.sending": "Gönderiliyor…",
  "message.status.failed": "Gönderilmedi",
  "message.status.sent": "Gönderilmiş",
  "message.status.delivered": "Teslim edilmiş",
  "message.status.read": "Okumak",
  "home.public_nav.pricing": "Fiyatlar",
  "home.public_nav.aria": "Ana sitede gezinme",
  "home.public_footer.aria": "Yasal bağlantılar",
  "home.pricing_link": "Planlar ve fiyatlar",
  "publicPricing.nav.back_home": "← Ana sayfa",
  "publicPricing.title": "Planlar ve fiyatlar",
  "publicPricing.subtitle": "ArChat abonelik motoruna yönelik şeffaf ve uyumlu sınırlar. Uluslararası ödeme için USD cinsinden ticari fiyatlar (ör. Paddle).",
  "publicPricing.commercial_note": "İşlevsel sınırlar PlanConstants/PlanResolver'dan gelir; hesabınız veritabanında plan_limits uygulayabilir. Satıcı ücretlendirmesinde belirtildiği gibi USD fiyatlandırmasıyla Paddle (veya resmi olarak ArChat tarafından belirlenen diğer işlemciler) kullanılır.",
  "publicPricing.plan.free": "FREE",
  "publicPricing.plan.foundation": "FOUNDATION",
  "publicPricing.plan.pro": "PRO",
  "publicPricing.price.free": "USD 0 / mes",
  "publicPricing.price.foundation": "USD {price} / mes",
  "publicPricing.price.pro": "USD {price} / mes",
  "publicPricing.same_limits_pro": "PRO (premium sözleşme) ile aynı teknik limitler.",
  "publicPricing.same_limits_foundation": "FOUNDATION (premium sözleşme) ile aynı teknik limitler.",
  "publicPricing.badge.foundation": "Programa Founder",
  "publicPricing.badge.pro": "Recomendado",
  "publicPricing.free.b1": "Hesap başına ayda 30.000 karakter.",
  "publicPricing.free.b2": "Kullanıcı başına en fazla 2 kişi; hesap başına en fazla 2 aktif görüşme.",
  "publicPricing.free.b3": "Ek veya depolama alanı yok; veri aktarımı olmadan.",
  "publicPricing.free.b4": "30 güne kadar mesaj geçmişi; Kullanıcı başına 1 cihaz.",
  "publicPricing.free.b5": "34 mesaj/gün ve 1.000 mesaj/ay (kiracı); Günde en fazla 20 davetiye.",
  "publicPricing.premium.b1": "Hesap başına ayda 300.000 karakter; Kullanıcı başına en fazla 100 kişi.",
  "publicPricing.premium.b2": "Sınırsız konuşma ve sohbet (kiracı); 1.667 mesaj/gün ve 50.000/ay.",
  "publicPricing.premium.b3": "50 MB'a kadar depolama alanı (kiracı); Kullanıcı başına en fazla 3 cihaz.",
  "publicPricing.premium.b4": "Sınırsız davetiye (kiracı); ihracat, otomatik çeviri ve dosyalar plana göre.",
  "publicPricing.premium.b5": "VAKIF: PRO ile aynı teknik sözleşme, artı Kurucu programı (150 yer). PRO: premium standart.",
  "publicPricing.foundation.founder_note": "Kurucunun ticari programı: sınırlı sayıda {slot} yer (plan özetine bakın). Abonelik etkinleştirildiğinde aynı PRO sınırları.",
  "publicPricing.cta.start_free": "Ücretsiz hesap oluştur",
  "publicPricing.cta.register_paid": "Hesap oluşturmak",
  "publicPricing.paddle_hint": "Seçilen işlemciyle ödeme, şarj etkinleştirildiğinde uygulama içinde tamamlanacaktır.",
  "publicPricing.legal.nav_label": "Yasal",
  "publicPricing.legal.terms": "Hizmet şartları",
  "publicPricing.legal.privacy": "Gizlilik Politikası",
  "publicPricing.legal.refund": "Geri Ödeme Politikası",
  "profile.security.privacy_note": "Hesabınızın gizliliğini ve güvenliğini yönetin.",
  "profile.security.sessions_title": "Aktif oturumlar",
  "profile.security.current": "Geçerli oturum",
  "profile.plan.foundation.description": "FOUNDATION Planı (Kurucu): Kurucu programı ve sınırlı alanı (150 koltuk) ile PRO ile aynı premium kullanım.",
  "billing.view_plans": "Planları görün",
  "billing.paddle.cancel_via_portal": "Aboneliği iptal et",
  "billing.paddle.test_access_denied_body": "Bu sunucuda faturalandırma işlemleri kısıtlanmıştır (test modu veya test listesi). Zaten gerçek bir hesapla ödeme yaptıysanız, üretimde tüm kullanıcılar için ödemeye izin verilmesi gerekir (ör. PAYMENTS_ALLOW_ALL_BILLING_USERS) veya bu kısıtlama devre dışı bırakılmalıdır. Desteğe başvurun.",
  "attachment.storage_insufficient_precheck.title": "Yetersiz alan",
  "attachment.storage_insufficient_precheck.message": "Dosyanın ağırlığı {fileSizeMb} MB'tır ve elinizde yalnızca {availableMb} MB kullanılabilir alan vardır. Yer açın veya devam etme planınızı geliştirin.",
  "attachment.files_disabled.title": "Plan sınırı",
  "attachment.files_disabled.message": "Mevcut planınız dosya göndermeyi içermiyor. Devam etme planınızı geliştirin.",
  "contacts.viewContactInfo": "İletişim ayrıntılarını görüntüle",
  "contacts.contactInfoTitle": "İletişim bilgileri",
  "contacts.phone": "Telefon",
  "contacts.bio": "Biyografi",
  "contacts.notProvided": "Bilgisiz",
  "contacts.unread.badge": "Okunmamış mesajlar",
  "dashboard.recentInbound.title": "Alınan son mesajlar",
  "dashboard.recentInbound.empty": "Yakın zamanda alınmış mesajınız yok.",
  "dashboard.recentInbound.error": "Mesajlar yüklenemedi.",
  "dashboard.recentInbound.previewPhoto": "Fotoğraf",
  "dashboard.recentInbound.previewFile": "Arşiv",
  "dashboard.recentInbound.previewPdf": "PDF'ler",
  "dashboard.recentInbound.previewUnavailable": "Mesaj kullanılamıyor",
  "dashboard.recentInbound.readTitle": "Okumak",
  "dashboard.recentInbound.unreadTitle": "okunmamış",
  "dashboard.recentConversations.title": "Son konuşmalar",
  "dashboard.recentConversations.empty": "Gösterilecek konuşma yok.",
  "dashboard.recentConversations.error": "Konuşmalar yüklenemedi.",
  "dashboard.plan.foundation": "FOUNDATION",
  "plan.errors.translationNotAllowed.title": "Çeviri mevcut değil",
  "plan.errors.translationNotAllowed.message": "Mevcut planınız diller arası otomatik çeviriyi içermiyor.",
  "plan.errors.translationNotAllowed.solution": "Otomatik çeviriyi kullanmak için planınızı yükseltin.",
  "billing.subscription.cancel_scheduled_date": "Aboneliğinizin {{date}} tarihinde iptal edilmesi planlanıyor. O zamana kadar planınızı kullanmaya devam edebilirsiniz.",
  "billing.subscription.cancel_scheduled_badge": "{{date}} tarihinde iptal edildi",
  "billing.scheduled.plan_after_cancel_label": "Dönem sonunda planlama:",
  "billing.scheduled.plan_free": "FREE (gratuito)",
  "billing.scheduled.plan_foundation": "FOUNDATION",
  "billing.scheduled.switch_to_foundation": "FOUNDATION olarak değiştir",
  "billing.scheduled.switch_to_free": "ÜCRETSİZ olarak değiştir",
  "billing.scheduled.foundation_full_title": "VAKIF mevcut değil",
  "billing.scheduled.foundation_full_message": "Şu anda FOUNDATION noktası yok. Planınız dönem sonunda ÜCRETSİZ'e düşecektir.",
  "billing.scheduled.saving": "Kaydediliyor...",
  "billing.scheduled.error_title": "Planı değiştirirken hata oluştu",
  "billing.scheduled.error_generic": "Planlanan plan değiştirilemedi. Tekrar deneyin.",
  "billing.cancel_scheduled.title": "Planlanmış iptal",
  "billing.cancel_scheduled.desc": "Aboneliğiniz {{date}} tarihinde iptal edilecek. O zamana kadar mevcut planınızı kullanmaya devam edebilirsiniz.",
  "billing.cancel_scheduled.no_new_plan_until_end": "Bu aboneliğin süresi dolana kadar başka bir planla sözleşme yapamayacaksınız.",
  "billing.cancel_scheduled.free_fallback": "Herhangi bir planı yenilemezseniz hesabınız ilgili sınırlamalarla birlikte ÜCRETSİZ olarak devam edecektir.",
  "billing.cancel_scheduled.profile_deactivation_hint": "Ayrıca profilinizden de platform aboneliğinden çıkabilirsiniz.",
  "billing.cancel_scheduled.default_free": "Dönem sonunda: ÜCRETSİZ",
  "google.missing_client_id": "Google ile Oturum Açma bu yapıda mevcut değil: VITE_GOOGLE_CLIENT_ID (veya __ARCHAT_TENANT_CONFIG__'de kiracı başına googleClientId) eksik.",
  "reviews.title": "ArChat İncelemeleri",
  "reviews.create_title": "ArChat'i nasıl derecelendirirsiniz?",
  "reviews.edit_title": "İncelememi düzenle",
  "reviews.comment_placeholder": "Bize deneyiminizi anlatın (isteğe bağlı)...",
  "reviews.submit_btn": "İncelemeyi gönder",
  "reviews.update_btn": "Güncelleme",
  "reviews.thank_you": "İncelemeniz için teşekkürler!",
  "reviews.submitted_message": "Fikriniz gelişmemize yardımcı oluyor.",
  "reviews.error_select_rating": "Bir derecelendirme seçin",
  "reviews.error_generic": "İnceleme gönderilirken hata oluştu",
  "reviews.prompt_message": "ArChat'i seviyor musunuz? Yorumunuzu bırakın!",
  "reviews.rate_now": "Kalifiye",
  "reviews.later": "Daha sonra",
  "reviews.write_review": "Yorum yaz",
  "reviews.edit_my_review": "İncelememi düzenle",
  "reviews.no_reviews": "Henüz yorum yok. İlk siz olun!",
  "reviews.review_singular": "gözden geçirmek",
  "reviews.review_plural": "yorumlar",
  "reviews.verified": "Doğrulandı",
  "reviews.anonymous": "Anonim",
  "files.storageUsed": "Kullanılan alan",
  "files.planQuota": "Kota planla",
  "files.availableStorage": "Mevcut",
  "files.usagePercent": "kullanılmış",
  "files.unlimited": "Sınırsız",
  "files.sentBy": "Gönderen",
  "files.unknownUser": "Kullanıcı",
  "settings.webPushSection": "Sistem bildirimleri (push/PWA)",
  "settings.webPushDescription": "Mobil cihazda uygulama arka plandayken veya kapalıyken bildirim alınmasına izin verir. Yapıda VAPID genel anahtarı (VITE_VAPID_PUBLIC_KEY) ve sunucuda anahtarlar gerekir. Tarayıcı iznini etkinleştirin ve bu cihazı kaydedin.",
  "settings.webPushButton": "Anlık bildirimleri etkinleştir",
  "settings.webPushRegistering": "Kaydediliyor…",
  "settings.webPushState.granted": "İzin verildi. VAPID doğru ayarlanmışsa günlük sunucuya gönderildi.",
  "settings.webPushState.denied": "İzin reddedildi. Lütfen tarayıcı ayarlarınızda bu site için bildirimleri etkinleştirin.",
  "settings.webPushState.default": "İzin istemek ve cihazı kaydetmek için düğmeye dokunun.",
  "settings.webPushState.unsupported": "Bu tarayıcı anlık bildirimleri desteklemiyor.",
  "settings.webPushVapidMissing": "Bu ön uç yapısında VITE_VAPID_PUBLIC_KEY eksik: Push aboneliği tamamlanamıyor.",
  "tags.etiquetas": "etiketler",
  "tags.manageTitle": "Etiketleri yönet",
  "tags.manage": "🏷️ Etiketler",
  "tags.allTags": "Tüm etiketler",
  "tags.confirmDelete": "Bu etiket kaldırılsın mı?",
  "tags.tagNamePlaceholder": "Etiket adı",
  "tags.create": "Yaratmak",
  "tags.noTags": "Etiket yok. Yukarıda bir tane oluşturun.",
  "tags.save": "Kale",
  "tags.edit": "Düzenlemek",
  "tags.delete": "Elemek",
  "tags.assignTo": "Ata",
  "tags.noTagsToAssign": "Etiket mevcut değil. Önce onları yaratın.",
  "tags.bgColor": "arka plan rengi",
  "tags.textColor": "Metin Rengi",
  "tags.selectTag": "Bir etiket seçin",
  "templates.selectTitle": "Şablonlar",
  "templates.noTemplates": "Şablon yok. Yukarıda bir tane oluşturun.",
  "templates.manage": "Şablonları yönet",
  "templates.confirmDelete": "Bu şablon silinsin mi?",
  "templates.manageTitle": "Şablonları yönet",
  "templates.titlePlaceholder": "Şablon Başlığı",
  "templates.bodyPlaceholder": "Şablon mesajını yazdım...",
  "templates.create": "Şablon oluştur",
  "templates.save": "Kale",
  "templates.edit": "Düzenlemek",
  "templates.delete": "Elemek",
};

